import $$ from 'dom7';

import HomePage from '../pages/home.f7.html';
import LoginPage from '../pages/login.f7.html';
import LoginPage2 from '../pages/login2.f7.html';
import RegisterPage from '../pages/register.f7.html';
import PaymentPage from '../pages/payment.f7.html';
import LockerPage from '../pages/locker.f7.html';
import DepositPage from '../pages/deposit.f7.html';
import DepositMoneyPage from '../pages/deposit-money.f7.html';
import TransferPage from '../pages/transfer.f7.html';
import TransactionPage from '../pages/transaction.f7.html';
import InvestPage from '../pages/invest.f7.html';
import InvestDashboardPage from '../pages/invest-dashboard.f7.html';
import ReturnPage from '../pages/returns.f7.html';
import InvestWithdrawPage from '../pages/invest-withdraw.f7.html';
import MoneyTransferPage from '../pages/money-transfer.f7.html';
import FeesTransactionPage from '../pages/fees.f7.html';
import EarningPage from '../pages/earning.f7.html';
import MyTeamPage from '../pages/my-team.f7.html';

import NotFoundPage from '../pages/404.f7.html';
var baseURL = "https://vyoorajewels.com/";
let INR = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 0,
});
let INR2 = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 2,
});
const isPlay = false;
var routes = [
  {
    path: '/',
    component: HomePage,
    name: 'Home',
    on: {
      pageInit: function (e, page) {
        var app = this.app;
        //get helpline Number
        app.methods.getSettings(function(data) {
          $$('.helpLinenumber').html(data.help);
          $$('.js-help-line-call').attr('href', 'tel:+91'+data.help);
          $$('.telegram-link').attr('href', data.telegram);
        });
        //swiper slider
        // var swiper = app.swiper.create('.swiper-container', {
        //   slidesPerView: 'auto',
        //   spaceBetween: 10,
        //   centeredSlides: true,
        //   autoplay: {
        //     delay: 5000,
        //     disableOnInteraction: true,
        //   },
        //   pagination: {
        //     el: '.swiper-pagination',
        //     clickable: true,
        //   },
        // });
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(data) {
          if(data.isLoggedin == 'true') {
            app.dialog.close();
            $$('.referral-code').html(data.referralCode);
            $$('.invite-link-btn').attr('data-referral', data.referralCode);
            $$('.profile-name').html(data.name);
            $$('.loggeninProfileUI').attr('src','https://ui-avatars.com/api/?background=fbd2e4&color=ed1e79&length=2&rounded=true&bold=true&name='+data.name);
            $$('.profile-email').html(data.email);
            $$('.profile-phone').html('+91'+data.phone);
            $$('.profile-address').html(data.address);
            $$('.profile-dob').html(data.dob);
            $$('.profile-link').attr('href','#');
            $$('.profile-link').addClass('popup-open');
            $$('.profile-link').attr('data-popup','#profile-popup');
            $$('.buy__link').attr('href','/invest/');
            //dashboard
            //check if isPlay is true
            // if(isPlay) {
            //   var link = 'https://app.vyoorajewels.com/';
            //   $$('.item__link--locker').attr('href',link);
            //   $$('.item__link--transaction').attr('href',link);
            //   $$('.item__link--deposit').attr('href',link);
            //   $$('.item__link--withdraw').attr('href',link);
            //   $$('.invest-btn--home').attr('href',link);
            //   $$('.wallet__link').addClass('external');
            //   $$('.wallet__link').attr('target','_system');
            //   $$('.invest__card').addClass('hidden');
            //   $$('.game__card').addClass('hidden');
            // } else {
            //   $$('.item__link--locker').attr('href','/locker/');
            //   $$('.item__link--transaction').attr('href','/transaction/wallet');
            //   $$('.item__link--deposit').attr('href','/deposit/');
            //   $$('.item__link--withdraw').attr('href','/withdraw/');
            //   $$('.invest-btn--home').attr('href','/invest/');
            //   $$('.invest__card').removeClass('hidden');
            //   $$('.game__card').removeClass('hidden');
            //   $$('.item_link--transfer').attr('href','/money-transfer/');
            // }
            //get investment details
            app.methods.getUserDataInvest(function(data) {
              if(data.status == 'success') {
                $$('.vault__link').attr('href','/invest-dashboard/');
              } else {
              }
            });
          } else {
            app.dialog.close();
            //remove authToken
            localStorage.removeItem('authToken');
            localStorage.setItem('isloggedIN', 'false');
          }
        });
        //copy-icon copy referral code
        $$('.copy-icon').on('click', function(e) {
          e.preventDefault();
          var text = $$('.referral-code').text();
          if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(text).then(function() {
              app.toast.show({text: 'Copied!', closeTimeout: 1500});
            });
          } else {
            // fallback for older browsers
            var tempInput = document.createElement('input');
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
            app.toast.show({text: 'Copied!', closeTimeout: 1500});
          }
        });
        // get live gold price in INR Free API
        // NOTE:
        // This API returns international *spot* XAU price converted to INR.
        // Indian market rates usually differ due to GST (3%) + local premium/making/handling.
        // Tune PREMIUM_RATE if you want closer matching to your local city/jeweller.
        $.getJSON('https://data-asg.goldprice.org/dbXRates/INR')
          .done(function (data) {
            var spotPerOunceInINR = Number(data && data.items && data.items[0] && data.items[0].xauClose);
            if (!spotPerOunceInINR) return;

            const OZ_TO_GRAM = 31.1034768;

            // Purity factors
            const PURITY_24K = 1.0;
            const PURITY_22K = 0.9167;
            const PURITY_21K = 0.875;
            const PURITY_18K = 0.75;

            // India adjustments (approx)
            const GST_RATE = 0.03; // 3% GST
            const PREMIUM_RATE = 0.0; // e.g. 0.01 = +1% (set as needed)
            const INDIA_FACTOR = (1 + GST_RATE) * (1 + PREMIUM_RATE);

            // Base spot per gram (24K)
            var spotPerGram24K = spotPerOunceInINR / OZ_TO_GRAM;

            // India approx prices (per gram)
            var pricePerGram24K = spotPerGram24K * PURITY_24K * INDIA_FACTOR;
            var pricePerGram22K = spotPerGram24K * PURITY_22K * INDIA_FACTOR;
            var pricePerGram21K = spotPerGram24K * PURITY_21K * INDIA_FACTOR;
            var pricePerGram18K = spotPerGram24K * PURITY_18K * INDIA_FACTOR;

            // India commonly quotes per 10 grams
            var pricePer10g24K = pricePerGram24K * 10;
            var pricePer10g22K = pricePerGram22K * 10;
            var pricePer10g21K = pricePerGram21K * 10;
            var pricePer10g18K = pricePerGram18K * 10;

            // Update UI if these elements exist (safe if they don't)
            $$('.gold-price-24k-10g').text(INR2.format(pricePer10g24K));
            $$('.gold-price-22k-10g').text(INR2.format(pricePer10g22K));
            $$('.gold-price-21k-10g').text(INR2.format(pricePer10g21K));
            $$('.gold-price-18k-10g').text(INR2.format(pricePer10g18K));

            console.log(
              'Approx India Gold (incl GST' + (PREMIUM_RATE ? ' + premium' : '') + '):\n' +
              '24K: ' + INR2.format(pricePer10g24K) + ' /10g (' + INR2.format(pricePerGram24K) + ' /g)\n' +
              '22K: ' + INR2.format(pricePer10g22K) + ' /10g (' + INR2.format(pricePerGram22K) + ' /g)\n' +
              '21K: ' + INR2.format(pricePer10g21K) + ' /10g (' + INR2.format(pricePerGram21K) + ' /g)\n' +
              '18K: ' + INR2.format(pricePer10g18K) + ' /10g (' + INR2.format(pricePerGram18K) + ' /g)'
            );
          })
          .fail(function () {
            console.log('Failed to fetch gold price.');
          });
      }
    }
  },
  {
    path: '/login/',
    component: LoginPage,
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.methods.getUserData(
          function(data) {
            if(data.isLoggedin == 'true') {
              app.views.main.router.navigate({name: 'Home'});
            }
          }
        );
        $$('.lgNum').on('click',function(){
          if (typeof LOGIN_DISABLED !== 'undefined' && LOGIN_DISABLED) {
          app.toast.show({
            text: 'Login is temporarily disabled. Please try again later.',
            closeTimeout: 3000,
          });
          return;
          }
          if (!$$('#userLogin')[0].checkValidity()) {
          console.log('Check Validity!');
          } else {
          login();
          }
        });
        //user login
        function login() {
          var formdata = $('#userLogin').serialize();
          var data = formdata+'&checkLogin=true';
          app.methods.request(
            baseURL+'/app/php/ajaxAuthentication.php',
            data,
            'json',
            function() { app.dialog.progress('Loading...'); $$('.button').addClass('disabled'); },
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                localStorage.setItem('phone', data.phone);
                app.popup.open('.sheet-OTP--verification');
                //mask phone number only show last 4 digits
                var phone = data.phone;
                var masked = phone.replace(/.(?=.{4})/g, '*');
                $$('.sheet-OTP--verification--phonenumber').html(masked);
              }
              else if(data.code == 'deactivated') {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
              else if(data.code == 'not-verified') {
                localStorage.setItem('phone', data.phone);
                app.popup.open('.sheet-OTP--verification');
                var phone = data.phone;
                var masked = phone.replace(/.(?=.{4})/g, '*');
                $$('.sheet-OTP--verification--phonenumber').html(masked);
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
        //forget password
        $(document).off('click', '.fpBTN');
        $(document).on('click','.fpBTN',function(){
          if (!$$('#fp-username')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            Forgetpassword();
          }
        });
        function Forgetpassword() {
          var phone = $$('#fp-username').val();
          app.methods.request(
            baseURL+'/app/php/ajaxAuthentication.php',
            {forgetPass: true, mobile: phone},
            'json',
            function() {app.dialog.progress('Loading...'); $$('.button').addClass('disabled');},
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                app.popup.close('.sheet-forget--pass');
                app.popup.open('.sheet-forget--otp');
                localStorage.setItem('phone', data.phone);
                $$('.sheet-forget--otp--phonenumber').html(data.phone);
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
        //change password
        $(document).off('click', '.fpBTNotp');
        $(document).on('click','.fpBTNotp',function(e){
          e.preventDefault();
          if (!$$('#changePass')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            changePass();
          }
        });
        function changePass() {
          var formdata = $('#changePass').serialize();
          var data = formdata+'&phone='+localStorage.getItem('phone')+'&changePass=true';
          app.methods.request(
            baseURL+'/app/php/ajaxAuthentication.php',
            data,
            'json',
            function() {app.dialog.progress('Loading...'); $$('.button').addClass('disabled');},
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                app.popup.close('.sheet-forget--otp');
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
      }
    }
  },
  {
    path: '/authentication/token/:token',
    component: LoginPage2,
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        var token = page.route.params.token;
        app.methods.getUserData(
          function(data) {
            if(data.isLoggedin == 'true') {
              app.views.main.router.navigate({name: 'Home'});
            }
          }
        );
        if(token != 'null') {
          // auto login with token
          autoLogin(token);
        } else {
          app.dialog.close();
          app.toast.show({
            text: 'Authentication failed due to invalid token!',
            closeTimeout: 3000,
          });
        }
        function autoLogin(token) {
          var formdata = 'authToken='+token+'&autoLogin=true';
          app.methods.request(
          baseURL+'/app/php/ajaxAuthentication.php',
          formdata,
          'json',
          function() { $$('.button').addClass('disabled'); },
          function(data) {
            $$('.button').removeClass('disabled');
            app.dialog.close();
            $$('.block-auth').empty();
            $$('.block-auth').append('<img src="https://cdn-icons-png.flaticon.com/512/12484/12484055.png" alt="" height="85">\
              <h2 class="text-color-green fw-500" style="font-size:18px;">Authentication Successful</h2>\
                <p class="text-color-gray">You are being logged in. Please wait...</p>');
            if(data.status == 'success') {
              localStorage.setItem('authToken', data.token);
              localStorage.setItem('isloggedIN', true);
              setTimeout(() => {
                var view = app.views.current;
                view.router.navigate('/');
                app.dialog.close();
              }, 1000);
            }
            else {
              $$('.block-auth').empty();
              $$('.block-auth').append('<img src="https://cdn-icons-png.flaticon.com/512/2621/2621165.png" alt="" height="85">\
                <h2 class="text-color-red-deep fw-500">Authentication Failed</h2>\
                <p class="text-color-gray">Invalid or expired token. Please try logging in again.</p>');
            }
          },
          function() {
            $$('.button').removeClass('disabled');
            app.dialog.close();
            $$('.block-auth').empty();
              $$('.block-auth').append('<img src="https://cdn-icons-png.flaticon.com/512/2621/2621165.png" alt="" height="85">\
                <h2 class="text-color-red-deep fw-500">Authentication Failed</h2>\
                <p class="text-color-gray">Unable to connect to server. Please check your internet connection and try again.</p>');
          }
          );
        }
      }
    }
  },
  {
    path: '/register/referral/:referralCode',
    component: RegisterPage,
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        //get referral code from url
        var referralCode = page.route.params.referralCode;
        $$('#referral').val(referralCode);
        app.methods.getUserData(
          function(data) {
            if(data.isLoggedin == 'true') {
              app.views.main.router.navigate({name: 'Home'});
            }
          }
        );
        // var calendarDefault = app.calendar.create({
        //   inputEl: '#dob',
        //   closeOnSelect: true,
        //   dateFormat: 'dd/mm/yyyy',
        //   header: false
        // });
        $$('#dob').on('input', function() {
          let val = $$('#dob').val();
          // Remove all non-digits
          val = val.replace(/\D/g, '');
          // Format as dd/mm/yyyy
          if (val.length > 2 && val.length <= 4) {
            val = val.slice(0,2) + '/' + val.slice(2);
          } else if (val.length > 4) {
            val = val.slice(0,2) + '/' + val.slice(2,4) + '/' + val.slice(4,8);
          }
          $$('#dob').val(val);
        });
        //user registration
        $$('.btnSignup').on('click',function(){
          if (!$$('#userSignup')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            signup();
          }
        });
        $('#gender').select2({minimumResultsForSearch: -1, width: '100%'});
        //user signup
        function signup() {
          var formdata = $('#userSignup').serialize();
          var data = formdata+'&userSignup=true';
          app.methods.request(
            baseURL+'/app/php/ajaxAuthentication.php',
            data,
            'json',
            function() { app.dialog.progress('Loading...'); $$('.button').addClass('disabled'); },
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                localStorage.setItem('phone',data.phone);
                app.popup.open('.sheet-OTP--verification');
                $$('.sheet-OTP--verification--phonenumber').html(data.phone);
              }
              else if(data.code == 'exist') {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
      }
    }
  },
  {
    path: '/payment/locker/:id/:type',
    component: PaymentPage,
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        // initialize box-scope
        var boxes = document.querySelectorAll('.box');

        for(let i = 0; i < boxes.length; i++) {
          let box = boxes[i];
          app.methods.initDropEffect(box);
          app.methods.initImageUpload(box);
        }
        app.methods.initFileUpload();
        app.dialog.progress('Loading...');
        //get locker details from api
        var lockerId = page.route.params.id;
        var type = page.route.params.type;
        if(type == 'subscription') {
          $.getJSON(baseURL+"app/php/lockers.php?getLockerById=true&lockerID="+lockerId+"&token="+localStorage.getItem('authToken'), function() {
            app.dialog.close();
          })
          .done(function(data) {
            app.dialog.close();
            if(data.status == 'success') {
              if(data.locker.id == '1') {
                var img = 'assets/icons/gold.png';
                $$('.list-changeValid').removeClass('hidden');
              } else if(data.locker.id == '2') {
                var img = 'assets/icons/platinum.png';
                $$('.list-changeValid').removeClass('hidden');
              }
              else {
                var img = 'assets/icons/diamond.png';
              }
              $$('.locker-media img').attr('src',img);
              $$('.lockerName').html(data.locker.name);
              $$('.lockerPrice').html(INR.format(data.locker.renewalCharge2));
              $$('.lockerValid').html('Validity: 30 Days');
              //order summary
              $$('.lockerPriceO').html(INR2.format(data.locker.renewalCharge2));
              $$('.orderTax').html(INR2.format(data.locker.fee));
              //calculate payable amount
              var total = +data.locker.renewalCharge2 + +data.locker.fee;
              $$('.payableAmount').html(INR2.format(total));
            } else {
              app.toast.show({
                text: data.msg,
                closeTimeout: 3000,
              });
              //redirect to locker page
              var view = app.views.current;
              view.router.back('/locker/',{force:true});
            }
          })
          .fail(function() {
            app.dialog.close();
            app.toast.show({
              text: 'Something went wrong, please try again!',
              closeTimeout: 3000,
            });
          });
        } else {
          //get subscription details
          app.methods.getUserDataLocker(function(data) {
            if(data.status == 'success') {
              app.dialog.close();
              if(data.subscription.id == '1') {
                var img = 'assets/icons/gold.png';
              } else if(data.subscription.id == '2') {
                var img = 'assets/icons/platinum.png';
              } else {
                var img = 'assets/icons/diamond.png';
              }
              $$('.locker-media img').attr('src',img);
              $$('.lockerName').html(data.subscription.locker+' Plan Renewal');
              $$('.lockerPrice').html(INR.format(data.subscription.price));
              $$('.lockerValid').html('Validity: '+data.subscription.validity+' Days');
              //order summary
              $$('.lockerPriceO').html(INR2.format(data.subscription.price));
              $$('.orderTax').html(INR2.format(data.subscription.fee));
              //calculate payable amount
              var total = +data.subscription.price + +data.subscription.fee;
              $$('.payableAmount').html(INR2.format(total));
            } else {
              app.toast.show({
                text: data.msg,
                closeTimeout: 3000,
              });
              //redirect to locker page
              var view = app.views.current;
              view.router.back('/locker/',{force:true});
            }
          }
          );
        }
        app.methods.getBank(function(data) {
          if(data.type == 'UPI') {
            $$('.getBankdet').append('<div class="card card-main">\
            <div class="card-content">\
              <div class="list list__loanst">\
                <ul class="color-logo">\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"> <b>Beneficiary Name</b> </div>\
                        <div class="item-after text-color-blue f-12">'+data.beneficiary+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"> <b>Bank Name</b> </div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_name+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"><b>Account Number</b></div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_num+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"><b>IFSC Code</b></div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_ifsc+'</div>\
                      </div>\
                    </div>\
                  </li>\
                </ul>\
              </div>\
                <div class="credit-list creditStore text-align-center">\
                  <div class="block text-align-center">\
                    <img src="https://youpaywallet.com/'+data.upi_qrIMG+'" width="150" style="margin-top: 25px;"/>\
                    <div class="item-title text-color-blue"><b>UPI ID: '+data.upi_id+'</b></div>\
                  </div>\
                </div>\
            </div>\
          </div>');
          } else {
            $$('.getBankdet').append('<div class="card card-main">\
            <div class="card-content">\
              <div class="list list__loanst">\
                <ul class="color-logo">\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"> <b>Beneficiary Name</b> </div>\
                        <div class="item-after text-color-blue f-12">'+data.beneficiary+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"> <b>Bank Name</b> </div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_name+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"><b>Account Number</b></div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_num+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"><b>IFSC Code</b></div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_ifsc+'</div>\
                      </div>\
                    </div>\
                  </li>\
                </ul>\
              </div>\
            </div>\
          </div>');
          }
        });
        //on change of select box of validity
        $$('.select-valid').on('change', function() {
          var valid = this.value;
          //get locker details from api
          app.dialog.progress('Loading...');
          $.getJSON(baseURL+"app/php/lockers.php?getLockerById=true&lockerID="+lockerId+"&token="+localStorage.getItem('authToken'), function() {
            app.dialog.close();
          })
          .done(function(data) {
            app.dialog.close();
            if(data.status == 'success') {
              if(data.locker.id == '1') {
                var img = 'assets/icons/gold.png';
                $$('.list-changeValid').removeClass('hidden');
              } else if(data.locker.id == '2') {
                var img = 'assets/icons/platinum.png';
                $$('.list-changeValid').removeClass('hidden');
              }
              else {
                var img = 'assets/icons/diamond.png';
              }
              $$('.locker-media img').attr('src',img);
              $$('.lockerName').html(data.locker.name);
              if(valid == '30') {
                $$('.lockerPrice').html(INR.format(data.locker.renewalCharge2));
                var renewal = INR2.format(data.locker.renewalCharge2);
                var total = +data.locker.renewalCharge2 + +data.locker.fee;
              } else {
                $$('.lockerPrice').html(INR.format(data.locker.renewalCharge1));
                var renewal = INR2.format(data.locker.renewalCharge1);
                var total = +data.locker.renewalCharge1 + +data.locker.fee;
              }
              $$('.lockerValid').html('Validity: '+valid+' Days');
              //order summary
              $$('.lockerPriceO').html(renewal);
              $$('.orderTax').html(INR2.format(data.locker.fee));
              //calculate payable amount
              $$('.payableAmount').html(INR2.format(total));
            } else {
              app.toast.show({
                text: data.msg,
                closeTimeout: 3000,
              });
              //redirect to locker page
              var view = app.views.current;
              view.router.back('/locker/',{force:true});
            }
          });
        });
        //upload payment
        $$('#payment').on('change', function() {
          var paymentIMG = $$('#payment').prop('files')[0];
          var validity = $$('.select-valid').val();
          var formData = new FormData();
          if(type == 'subscription') {
            formData.append('subscribe', true);
            formData.append('token', localStorage.getItem('authToken'));
            formData.append('paymentIMG', paymentIMG);
            formData.append('lockerID', lockerId);
            formData.append('validity', validity);
          } else {
            formData.append('renewal', true);
            formData.append('token', localStorage.getItem('authToken'));
            formData.append('paymentIMG', paymentIMG);
          }
          var file = this.files[0];
          var fileType = file['type'];
          var validImageTypes = ["image/gif", "image/jpeg", "image/png", "image/jpg"];
          
          if(!$$('#payment')[0].checkValidity()) {
            app.toast.show({
              text: 'Please upload your payment screenshot!',
              closeTimeout: 3000,
            });
          }
          else if ($.inArray(fileType, validImageTypes) < 0) {
            app.toast.show({
              text: 'This is not an image, please upload an image!',
              closeTimeout: 3000,
            });
          }
          else {
            app.methods.post(
              baseURL+'app/php/lockers.php',
              formData,
              'json',
              function() {
                app.dialog.progress('Loading...');
              },
              function(data) {
                app.dialog.close();
                if(data.status == 'success') {
                  if(type == 'subscription') {
                    $$('.sheet-loan--applied__title').html('Success!');
                    $$('.sheet-loan--applied__text').html('You\'ve successfully requested for a locker subscription, please wait while we\'re verifying your payment.');
                    app.popup.open('.sheet-loan--applied');
                  } else {
                    $$('.sheet-loan--applied__title').html('Success!');
                    $$('.sheet-loan--applied__text').html('You\'ve successfully requested for a locker renewal, please wait while we\'re verifying your payment.');
                    app.popup.open('.sheet-loan--applied');
                  }
                  var view = app.views.current;
                  view.router.back('/',{force:true});
                }
                else {
                  app.toast.show({
                    text: data.msg,
                    closeTimeout: 3000,
                  });
                }
              },
              function() {
                app.dialog.close();
                app.toast.show({
                text: 'Something went wrong, please try again!',
                closeTimeout: 3000,
              });
              }
            );
          }
      });
      }
    }
  },
  {
    path: '/fees/transaction/:txnID',
    component: FeesTransactionPage,
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        // initialize box-scope
        var boxes = document.querySelectorAll('.box');

        for(let i = 0; i < boxes.length; i++) {
          let box = boxes[i];
          app.methods.initDropEffect(box);
          app.methods.initImageUpload(box);
        }
        app.methods.initFileUpload();
        app.dialog.progress('Loading...');
        //get locker details from api
        var txnID = page.route.params.txnID;
        //last transaction details
        app.methods.request(
          baseURL+'/app/php/lockers.php',
          {getLastWithdrawal: true, token: localStorage.getItem('authToken'), txnID: txnID},
          'json',
          function() { app.dialog.progress('Loading...'); },
          function(data) {
            app.dialog.close();
            if(data.status == 'success') {
              if(data.lastWithdrawal) {
                $$('.wamount').html(INR2.format(data.lastWithdrawal.amount));
                $$('.wfee').html(INR2.format(data.lastWithdrawal.withdrawalFee));
                //calculate payable amount
                var total = +data.lastWithdrawal.withdrawalFee;
                $$('.payableAmount').html(INR2.format(total));
              } else {
                console.log('No withdrawal details found.');
              }
            } else {
              app.toast.show({
                text: data.msg,
                closeTimeout: 3000,
              });
              setTimeout(() => {
                var view = app.views.current;
                view.router.back('/transaction/wallet',{force:true});
              }, 1000);
            }
          },
          function() {
            app.dialog.close();
            app.toast.show({
              text: 'No internet connection!',
              closeTimeout: 3000,
            });
            setTimeout(() => {
              var view = app.views.current;
              view.router.back('/transaction/wallet',{force:true});
            }, 1000);
          }
        );
        app.methods.getBank(function(data) {
          app.dialog.close();
          if(data.isUPI == '1' && data.isBank == '1') {
            $$('.getBankdet').append('<div class="card card-main">\
            <div class="card-content">\
              <div class="list list__loanst">\
                <ul class="color-logo">\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"> <b>Beneficiary Name</b> </div>\
                        <div class="item-after text-color-blue f-12">'+data.beneficiary+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"> <b>Bank Name</b> </div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_name+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"><b>Account Number</b></div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_num+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"><b>IFSC Code</b></div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_ifsc+'</div>\
                      </div>\
                    </div>\
                  </li>\
                </ul>\
              </div>\
                <div class="credit-list creditStore text-align-center">\
                  <div class="block text-align-center">\
                    <img src="https://youpaywallet.com/'+data.upi_qrIMG+'" width="150" style="margin-top: 25px;"/>\
                    <div class="item-title text-color-blue"><b>UPI ID: '+data.upi_id+'</b></div>\
                  </div>\
                </div>\
            </div>\
          </div>');
          } else if(data.isUPI == '1' && data.isBank == '0') {
            $$('.getBankdet').append('<div class="card card-main">\
              <div class="card-content">\
                <div class="credit-list creditStore text-align-center">\
                  <div class="block text-align-center">\
                    <img src="https://youpaywallet.com/' + data.upi_qrIMG + '" width="150" style="margin-top: 25px;"/>\
                    <div class="item-title text-color-blue"><b>UPI ID: ' + data.upi_id + '</b></div>\
                  </div>\
                </div>\
              </div>\
            </div>');
          } else if(data.isUPI == '0' && data.isBank == '1') {
            $$('.getBankdet').append('<div class="card card-main">\
            <div class="card-content">\
              <div class="list list__loanst">\
                <ul class="color-logo">\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"> <b>Beneficiary Name</b> </div>\
                        <div class="item-after text-color-blue f-12">'+data.beneficiary+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"> <b>Bank Name</b> </div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_name+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"><b>Account Number</b></div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_num+'</div>\
                      </div>\
                    </div>\
                  </li>\
                  <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                        <div class="item-title text-color-blue f-12"><b>IFSC Code</b></div>\
                        <div class="item-after text-color-blue f-12">'+data.acc_ifsc+'</div>\
                      </div>\
                    </div>\
                  </li>\
                </ul>\
              </div>\
            </div>\
          </div>');
          } else {
            console.log('No bank details found.');
          }
        });
        //upload payment
        $$('#payment').on('change', function() {
          var paymentIMG = $$('#payment').prop('files')[0];
          var utr = $$('#utrx').val();
          var validity = $$('.select-valid').val();
          var formData = new FormData();
          formData.append('withdrawalFee', true);
          formData.append('token', localStorage.getItem('authToken'));
          formData.append('paymentIMG', paymentIMG);
          formData.append('txnID', txnID);
          formData.append('utr', utr);
          var file = this.files[0];
          var fileType = file['type'];
          var validImageTypes = ["image/gif", "image/jpeg", "image/png", "image/jpg"];
          
          if(!$$('#payment')[0].checkValidity()) {
            app.toast.show({
              text: 'Please upload your payment screenshot!',
              closeTimeout: 3000,
            });
          }
          else if ($.inArray(fileType, validImageTypes) < 0) {
            app.toast.show({
              text: 'This is not an image, please upload an image!',
              closeTimeout: 3000,
            });
          }
          else if(utr == '') {
            app.toast.show({
              text: 'Please enter your UTR number!',
              closeTimeout: 3000,
            });
          }
          else {
            app.methods.post(
              baseURL+'app/php/lockers.php',
              formData,
              'json',
              function() {
                app.dialog.progress('Loading...');
              },
              function(data) {
                app.dialog.close();
                if(data.status == 'success') {
                  $$('.sheet-loan--applied__title').html('Success!');
                  $$('.sheet-loan--applied__text').html('Your payment is successfully submitted, please wait while we\'re verifying your payment.');
                  app.popup.open('.sheet-loan--applied');
                  var view = app.views.current;
                  view.router.back('/',{force:true});
                }
                else {
                  app.toast.show({
                    text: data.msg,
                    closeTimeout: 3000,
                  });
                }
              },
              function() {
                app.dialog.close();
                app.toast.show({
                text: 'Something went wrong, please try again!',
                closeTimeout: 3000,
              });
              }
            );
          }
      });
      }
    }
  },
  {
    path: '/locker/',
    component: LockerPage,
    name: 'locker',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        app.methods.getUserData(
          function(data) {
            if(data.isLoggedin == 'true') {
              app.dialog.close();
              //get subscription details
              app.methods.getUserDataLocker(function(data) {
                if(data.status == 'success') {
                  $$('.if_locker--locked').addClass('hidden');
                  $$('.toolbar-locker').addClass('hidden');
                  $$('.if_locker--unlocked').removeClass('hidden');
                  $$('.if_locker--unlocked').empty();
                  $$('.if_lockerlist--unlocked').removeClass('hidden');
                  if(data.subscription.id == '1') {
                    var img = 'assets/icons/gold.png';
                  } else if(data.subscription.id == '2') {
                    var img = 'assets/icons/platinum.png';
                  } else {
                    var img = 'assets/icons/diamond.png';
                  }
                  if(data.subscription.status == '0') {
                    var status = 'Pending';
                    var statusColor = 'text-color-orange';
                    var action = 'Please wait while we\'re verifying your payment.';
                    var expire = '';
                    var renew = 'disabled';
                    var renewLink = '';
                  } else if(data.subscription.status == '1') {
                    var status = 'Active';
                    var statusColor = 'text-color-green';
                    var action = 'Your locker is active, you can now use it.';
                    var expire = 'Expires on '+data.subscription.expire;
                    var renew = '';
                    var renewLink = '/payment/locker/'+data.subscription.id+'/renewal';
                  } else {
                    var status = 'Expired';
                    var statusColor = 'text-color-red-deep';
                    var action = 'Your locker is expired, please renew it to use it.';
                    var expire = 'Expired on '+data.subscription.expire;
                    var renew = '';
                    var renewLink = '/payment/locker/'+data.subscription.id+'/renewal';
                  }
                  $$('.if_locker--unlocked').append('<div class="card card-main" style="padding: 5px;">\
                  <div class="card-content">\
                    <div class="list media-list">\
                      <ul class="color-logo">\
                        <li>\
                          <div class="item-link item-content">\
                            <div class="item-media locker-media"><img src="'+img+'" height="80"/></div>\
                            <div class="item-inner">\
                              <div class="item-text text-color-blue fw-600 f-16">'+data.subscription.locker+' Plan</div>\
                              <div class="item-subtitle f-12 '+statusColor+'">'+status+'</div>\
                              <div class="item-text f-12">'+action+'</div>\
                              <div class="item-text f-14 fw-600 '+statusColor+'">'+expire+'</div>\
                              <a href="'+renewLink+'" class="button button-fill button-round margin-top bg-color-red text-color-white button-small w-50 '+renew+'">Renew</a>\
                            </div>\
                          </div>\
                        </li>\
                      </ul>\
                    </div>\
                  </div>\
                  </div>');
                } else {
                  //get locker details from api
                  $.getJSON(baseURL+"app/php/lockers.php?getLocker=true&token="+localStorage.getItem('authToken'), function() {
                    app.dialog.close();
                  })
                  .done(function(data) {
                    app.dialog.close();
                    if(data.status == 'success') {
                      $$('.grid-lockers').empty();
                      //each function
                      $.each(data.lockers, function(i, item) {
                        if(i == 0) {
                          var checked = 'checked';
                        } else {
                          var checked = '';
                        }
                        if(item.id == '1') {
                          var img = 'assets/icons/gold.png';
                          var deposit = INR.format(item.depositLimit);
                        } else if(item.id == '2') {
                          var img = 'assets/icons/platinum.png';
                          var deposit = INR.format(item.depositLimit);
                        } else {
                          var img = 'assets/icons/diamond.png';
                          var deposit = 'Unlimited';
                        }
                        $$('.grid-lockers').append('<label class="card-lockers">\
                        <input name="plan" class="radio" type="radio" '+checked+' value="'+item.id+'">\
                        <span class="plan-details">\
                          <img src="'+img+'" width="100" class="m-auto"/>\
                          <span class="plan-type margin-top">'+item.name+'</span>\
                          <span class="plan-cost text-color-blue">'+INR.format(item.renewalCharge2)+'<span class="slash">/</span><abbr class="plan-cycle" title="month">month</abbr></span>\
                          <span class="text-color-blue f-14 text-align-justify display-flex flex-direction-column locker-details">\
                          <span><i class="icon f7-icons f-20 text-color-red">checkmark_alt_circle_fill</i> '+item.maximumAC+' Virtual A/C</span>\
                          <span><i class="icon f7-icons f-20 text-color-red">checkmark_alt_circle_fill</i> '+deposit+' Deposit Limit Daily</span>\
                          <span><i class="icon f7-icons f-20 text-color-red">checkmark_alt_circle_fill</i> '+item.withdrawalLimit+' Withdrawal Request Daily</span>\
                          <span><i class="icon f7-icons f-20 text-color-red">checkmark_alt_circle_fill</i> '+item.withdrawalFee+'% Withdrawal Charge</span>\
                          <span><i class="icon f7-icons f-20 text-color-red">checkmark_alt_circle_fill</i> '+item.return+'% Cashback on Withdrawal Charge</span>\
                          </span>\
                        </span>\
                      </label>');
                      });
                    }
                  })
                  .fail(function() {
                    app.dialog.close();
                    app.toast.show({
                      text: 'Something went wrong, please try again!',
                      closeTimeout: 3000,
                    });
                  });
                }
              });
            } else {
              app.dialog.close();
              app.views.main.router.navigate({name: 'Home'});
            }
          }
        );
        //locker submit
        $$('.subscribe-locker').on('click', function() { 
          //get selected locker
          var locker = $$('.radio:checked').val();
          //redirect to payment page
          app.views.main.router.navigate('/payment/locker/'+locker+'/subscription');
        });
      }
    }
  },
  {
    path: '/deposit/',
    component: DepositPage,
    name: 'deposit',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        //get subscription details
        app.methods.getUserDataLocker(function(data) {
          app.dialog.close();
          if(data.status == 'success') {
            //create virtual account list
            $$('.block-virtual-account .list ul').empty();
            $.each(data.accounts, function(i, item) {
              $$('.block-virtual-account .list ul').append('<li>\
              <div class="item-content">\
                <div class="item-inner">\
                  <div class="item-title">'+item.bankName+'</div>\
                  <div class="item-subtitle">A/C: '+item.bankAC+'</div>\
                  <div class="item-text">IFSC: '+item.bankIFSC+'</div>\
                </div>\
                <div class="item-after">\
                <a href="/deposit-money/account/'+item.id+'" class="button button-fill bg-color-red text-color-white button-small w-100 margin-right">Deposit</a>\
                </div>\
              </div>\
            </li>');
            //check if deposit limit is numeric or not
            if(!isNaN(data.subscription.depositLimit)) {
              $$('.depositLimit').html('You can deposit <strong>'+INR.format(data.subscription.depositLimit)+'</strong> amount into your wallet through these bank accounts daily.');
            } else {
              $$('.depositLimit').html('You can deposit <strong>Unlimited</strong> amount into your wallet through these bank accounts daily.');
            }
            }
            );
          } else {
            app.toast.show({
              text: data.msg,
              closeTimeout: 3000,
            });
            //redirect to home page
            var view = app.views.current;
            view.router.navigate({name: 'Home'});
          }
        }
        );
      }
    }
  },
  {
    path: '/deposit-money/:account/:accountID',
    component: DepositMoneyPage,
    name: 'deposit-money',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        var accountID = page.route.params.accountID;
        // initialize box-scope
        var boxes = document.querySelectorAll('.box');

        for(let i = 0; i < boxes.length; i++) {
          let box = boxes[i];
          app.methods.initDropEffect(box);
          app.methods.initImageUpload(box);
        }
        app.methods.initFileUpload();
        app.dialog.progress('Loading...');
        //get account details by accountID
        $.getJSON(baseURL+"app/php/lockers.php?getAccountByID=true&accountID="+accountID+"&token="+localStorage.getItem('authToken'), function() {
          app.dialog.close();
        })
        .done(function(data) {
          app.dialog.close();
          if(data.status == 'success') {
            $$('.bankName').html(data.account.bankName);
            $$('.bankAccount').html('A/C: '+data.account.bankAC);
            $$('.bankIFSC').html('IFSC: '+data.account.bankIFSC);
            $$('input[name="accountID"]').val(data.account.id);
          } else {
            app.toast.show({
              text: data.msg,
              closeTimeout: 3000,
            });
            //redirect to locker page
            var view = app.views.current;
            view.router.back('/deposit/',{force:true});
          }
        })
        .fail(function() {
          app.dialog.close();
          app.toast.show({
            text: 'Something went wrong, please try again!',
            closeTimeout: 3000,
          });
        });
        //upload deposit receipt
        $$('.depositMoney').on('click', function() {
          var depositIMG = $$('#depositReceipt').prop('files')[0];
          var utr = $$('#utr').val();
          var formData = new FormData();
          formData.append('deposit', true);
          formData.append('token', localStorage.getItem('authToken'));
          formData.append('depositIMG', depositIMG);
          formData.append('accountID', accountID);
          formData.append('utr', utr);
          formData.append('amount', $$('#amount').val());
          if(!$$('#amount')[0].checkValidity()) {
            app.toast.show({
              text: 'Please enter your deposit amount!',
              closeTimeout: 3000,
            });
          }
          else if(!$$('#utr')[0].checkValidity()) {
            app.toast.show({
              text: 'Please enter your UTR number!',
              closeTimeout: 3000,
            });
          }
          else if(!$$('#depositReceipt')[0].checkValidity()) {
            app.toast.show({
              text: 'Please upload your deposit receipt!',
              closeTimeout: 3000,
            });
          }
          else {
            var file = $$('#depositReceipt').prop('files')[0];
            var fileType = file['type'];
            var validImageTypes = ["image/gif", "image/jpeg", "image/png", "image/jpg"];
            if ($.inArray(fileType, validImageTypes) < 0) {
              app.toast.show({
                text: 'This is not an image, please upload an image!',
                closeTimeout: 3000,
              });
            } else {
              app.methods.post(
                baseURL+'app/php/lockers.php',
                formData,
                'json',
                function() {
                  app.dialog.progress('Loading...');
                },
                function(data) {
                  app.dialog.close();
                  if(data.status == 'success') {
                    app.popup.open('.sheet-loan--applied');
                    $$('.sheet-loan--applied__title').html(INR2.format(data.amount)+' Deposit Requested!');
                    $$('.sheet-loan--applied__text').html('Your wallet balance will be updated once we verify your deposit, please wait while we\'re verifying your deposit.');
                    var view = app.views.current;
                    view.router.back('/',{force:true});
                  }
                  else {
                    app.toast.show({
                      text: data.msg,
                      closeTimeout: 3000,
                    });
                  }
                },
                function() {
                  app.dialog.close();
                  app.toast.show({
                  text: 'Something went wrong, please try again!',
                  closeTimeout: 3000,
                });
                }
              );
            }
          }
        });
      }
    }
  },
  {
    path: '/withdraw/',
    component: TransferPage,
    name: 'transfer',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        //get subscription details
        app.methods.getUserDataLocker(function(data) {
          app.dialog.close();
          if(data.status == 'success') {
            $$('.wallet--amount').html(INR2.format(data.subscription.wallet));
            $$('input[name="amount"]').attr('max', data.subscription.wallet);
            $$('input[name="fee"]').val(data.subscription.withdrawalFee);
            $$('input[name="wallet"]').val(data.subscription.wallet);
            //check if bankAccounts is array or not
            if(Array.isArray(data.bankAccounts) && data.bankAccounts.length > 0) {
              $$('#transferMoney').removeClass('hidden');
              $$('.beneficiaryContent').addClass('hidden');
              $$('.selectBeneficiaryList').removeClass('hidden');
              var allBankAccounts = data.bankAccounts;
              //create bank account select list in selectBeneficiary
              $$('.selectBeneficiary').empty();
              allBankAccounts.forEach(function(account, idx) {
                $$('#selectBeneficiary').append(
                  '<option value="'+account.bankAC+'"'
                  + ' data-beneficiary="'+account.beneficiaryName+'"'
                  + ' data-bankname="'+account.bankName+'"'
                  + ' data-ifsc="'+account.bankIFSC+'"'
                  + ' data-receiverphone="'+account.receiverPhone+'"'
                  + ' data-receiveremail="'+account.receiverMail+'"'
                  + (idx === 0 ? ' selected' : '')
                  + '>'
                  + account.beneficiaryName+' - '+account.bankAC+' ('+account.bankName+')'
                  + '</option>'
                );
              });
              //init select2
              $('#selectBeneficiary').select2();
              $$('.block-beneficiaryDetails').removeClass('hidden');
              //first show selected beneficiary details
              var selectedBeneficiary = $('#selectBeneficiary option:selected');
              $$('.block-beneficiaryDetails').empty();
              $$('.block-beneficiaryDetails').append('<div class="card card-main">\
                <div class="card-content">\
                  <p class="text-color-blue f-14"><b>Beneficiary Name:</b> '+selectedBeneficiary.data('beneficiary')+'</p>\
                  <p class="text-color-blue f-14"><b>Bank Name:</b> '+selectedBeneficiary.data('bankname')+'</p>\
                  <p class="text-color-blue f-14"><b>Account Number:</b> '+selectedBeneficiary.val()+'</p>\
                  <p class="text-color-blue f-14"><b>IFSC Code:</b> '+selectedBeneficiary.data('ifsc')+'</p>\
                  <p class="text-color-blue f-14"><b>Beneficiary Phone:</b> '+selectedBeneficiary.data('receiverphone')+'</p>\
                  <p class="text-color-blue f-14"><b>Beneficiary Email:</b> '+selectedBeneficiary.data('receiveremail')+'</p>\
                </div>\
              </div>');
              //beneficiary content add value to each field
              $$('.beneficiaryContent #beneficiary').val(selectedBeneficiary.data('beneficiary'));
              $$('.beneficiaryContent #bankname').val(selectedBeneficiary.data('bankname'));
              $$('.beneficiaryContent #account').val(selectedBeneficiary.val());
              $$('.beneficiaryContent #caccount').val(selectedBeneficiary.val());
              $$('.beneficiaryContent #ifsc').val(selectedBeneficiary.data('ifsc'));
              $$('.beneficiaryContent #receiverPhone').val(selectedBeneficiary.data('receiverphone'));
              $$('.beneficiaryContent #receiverEmail').val(selectedBeneficiary.data('receiveremail'));
              //on change of select box of beneficiary
              $('#selectBeneficiary').on('change', function() {
                var selectedBeneficiary = $('#selectBeneficiary option:selected');
                $$('.block-beneficiaryDetails').empty();
                $$('.block-beneficiaryDetails').append('<div class="card card-main">\
                  <div class="card-content">\
                    <p class="text-color-blue f-14"><b>Beneficiary Name:</b> '+selectedBeneficiary.data('beneficiary')+'</p>\
                    <p class="text-color-blue f-14"><b>Bank Name:</b> '+selectedBeneficiary.data('bankname')+'</p>\
                    <p class="text-color-blue f-14"><b>Account Number:</b> '+selectedBeneficiary.val()+'</p>\
                    <p class="text-color-blue f-14"><b>IFSC Code:</b> '+selectedBeneficiary.data('ifsc')+'</p>\
                    <p class="text-color-blue f-14"><b>Beneficiary Phone:</b> '+selectedBeneficiary.data('receiverphone')+'</p>\
                    <p class="text-color-blue f-14"><b>Beneficiary Email:</b> '+selectedBeneficiary.data('receiveremail')+'</p>\
                  </div>\
                </div>');
                //beneficiary content add value to each field
                $$('.beneficiaryContent #beneficiary').val(selectedBeneficiary.data('beneficiary'));
                $$('.beneficiaryContent #bankname').val(selectedBeneficiary.data('bankname'));
                $$('.beneficiaryContent #account').val(selectedBeneficiary.val());
                $$('.beneficiaryContent #caccount').val(selectedBeneficiary.val());
                $$('.beneficiaryContent #ifsc').val(selectedBeneficiary.data('ifsc'));
                $$('.beneficiaryContent #receiverPhone').val(selectedBeneficiary.data('receiverphone'));
                $$('.beneficiaryContent #receiverEmail').val(selectedBeneficiary.data('receiveremail'));
              });
            } else {
              $$('#transferMoney').removeClass('hidden');
              $$('.beneficiaryContent').addClass('hidden');
              $$('.selectBeneficiaryList').addClass('hidden');
            }
            //create sheet-add-beneficiary
            // Create Add Beneficiary Sheet
            var addBeneficiarySheet = app.sheet.create({
              content: `
              <div class="sheet-modal sheet-add-beneficiary" style="height:auto;">
              <div class="toolbar">
                <div class="toolbar-inner">
                  <div class="title text-color-blue margin-left"><h3 class="text-color-blue text-align-left">Add Beneficiary</h3></div>
                  <div class="right">
                    <a href="#" class="link sheet-close">
                      <img src="assets/icons/x-button.png" width="24" height="24" alt="Close" class="icon icon-close">
                    </a>
                  </div>
                </div></div>
                <div class="sheet-modal-inner">
                <div class="sheet-modal-text">
                  <form id="addBeneficiaryForm">
                  <div class="list">
                    <ul>
                    <li class="item-content item-input ">
                      <div class="item-inner">
                          <div class="item-title item-floating-label" style="background-color: #FFF !important">Beneficiary Name</div>
                          <div class="item-input-wrap">
                              <div class="flex d-row">
                                  <input type="text" name="bnbeneficiary" id="bnbeneficiary" required validate>
                              </div>
                          </div>
                      </div>
                    </li>
                    <li class="item-content item-input ">
                        <div class="item-inner">
                            <div class="item-title item-floating-label" style="background-color: #FFF !important">Beneficiary Phone (Optional)</div>
                            <div class="item-input-wrap">
                                <div class="flex d-row">
                                    <input type="tel" maxlength="10" minlength="10" name="bnreceiverPhone" id="bnreceiverPhone">
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="item-content item-input ">
                        <div class="item-inner">
                            <div class="item-title item-floating-label" style="background-color: #FFF !important">Beneficiary Email (Optional)</div>
                            <div class="item-input-wrap">
                                <div class="flex d-row">
                                    <input type="email" name="bnreceiverEmail" id="bnreceiverEmail" validate>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="item-content item-input ">
                        <div class="item-inner">
                            <div class="item-title item-floating-label" style="background-color: #FFF !important">Account Number</div>
                            <div class="item-input-wrap">
                                <div class="flex d-row">
                                    <input type="password" name="bnaccount" id="bnaccount" required validate>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="item-content item-input ">
                        <div class="item-inner">
                            <div class="item-title item-floating-label" style="background-color: #FFF !important">Confirm Account Number</div>
                            <div class="item-input-wrap">
                                <div class="flex d-row">
                                    <input type="tel" name="bncaccount" id="bncaccount" required validate>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="item-content item-input ">
                        <div class="item-inner">
                            <div class="item-title item-floating-label" style="background-color: #FFF !important">IFSC Code</div>
                            <div class="item-input-wrap">
                                <div class="flex d-row">
                                    <input type="text" name="bnifsc" id="bnifsc" minlength="11" maxlength="11" required validate>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="item-content item-input item-input-bank">
                        <div class="item-inner">
                            <div class="item-title item-floating-label" style="background-color: #FFF !important">Bank Name</div>
                            <div class="item-input-wrap">
                                <div class="flex d-row">
                                    <input type="text" name="bnbankname" id="bnbankname" required validate>
                                </div>
                            </div>
                        </div>
                    </li>
                    </ul>
                  </div>
                  <div class="block">
                    <button type="submit" class="button button-large button-fill color-blue bg-color-red addBeneficiaryBtn">Add Beneficiary</button>
                  </div>
                  </form>
                </div>
                </div>
              </div>
              `,
              swipeToClose: true,
              backdrop: true,
              // Events
              on: {
                open: function() {
                  // Reset form fields
                  $$('#addBeneficiaryForm')[0].reset();
                  $$('.item-input-bank').removeClass('item-input-focused item-input-with-value');
                },
                opened: function() {
                  //get ifsc
                  $(document).on('keyup', '#bnifsc', function() {
                    if($$('#bnifsc').val().length == 11) {
                      app.preloader.show();
                      $.getJSON('https://ifsc.razorpay.com/'+$$('#bnifsc').val(), function(data) {app.preloader.hide();})
                      .done(function(data) {
                        app.preloader.hide();
                        $$('#bnbankname').val(data.BANK);
                        $$('.item-input-bank').addClass('item-input-focused');
                        $$('.item-input-bank').addClass('item-input-with-value');
                      })
                      .fail(function() {
                        app.preloader.hide();
                        app.toast.show({
                          text: 'Invalid IFSC code!',
                          closeTimeout: 3000,
                        });
                      })
                    }
                  });
                  // Handle Add Beneficiary Form Submission
                  $$(document).on('submit', '#addBeneficiaryForm', function(e) {
                    e.preventDefault();
                    //check if account number and confirm account number are same
                    if($$('#bnaccount').val() !== $$('#bncaccount').val()) {
                      app.toast.show({
                        text: 'Account number and confirm account number do not match!',
                        closeTimeout: 3000,
                      });
                      return;
                    }
                    var formData = app.form.convertToData('#addBeneficiaryForm');
                    formData.addBeneficiary = true;
                    formData.token = localStorage.getItem('authToken');
                    app.dialog.progress('Adding...');
                    app.request.post(
                    baseURL + '/app/php/lockers.php',
                    formData,
                    function(res) {
                      app.dialog.close();
                      var data = {};
                      try { data = JSON.parse(res); } catch(e) {}
                      if (data.status === 'success') {
                      app.toast.show({ text: 'Beneficiary added successfully!', closeTimeout: 2000 });
                      addBeneficiarySheet.close();
                      // Optionally, reload the page or update the beneficiary list here
                      //RELOAD CURRENT PAGE
                      var view = app.views.current;
                      view.router.navigate('/withdraw/', {
                        reloadCurrent: true,
                        ignoreCache: true,
                      })
                      } else {
                      app.toast.show({ text: data.msg || 'Failed to add beneficiary.', closeTimeout: 3000 });
                      }
                    },
                    function() {
                      app.dialog.close();
                      app.toast.show({ text: 'No internet connection!', closeTimeout: 3000 });
                    }
                    );
                  });
                },
                close: function() {
                  // Reset form fields
                  $$('#addBeneficiaryForm')[0].reset();
                  $$('.item-input-bank').removeClass('item-input-focused item-input-with-value');
                }
              }
            });

            // Open Add Beneficiary Sheet on button click
            $$('.add-beneficiary-btn').on('click', function() {
              addBeneficiarySheet.open();
            });
            //check if withdrawal limit is numeric or not
            if(!isNaN(data.subscription.withdrawalLimit)) {
              $$('.withdrawalLimit').html('You can withdraw from your wallet upto <strong>'+INR.format(data.subscription.withdrawalLimit)+'</strong> per transaction with a charge of <strong>'+data.subscription.withdrawalFee+'%</strong> per withdrawal.');
            }
            else {
              $$('.withdrawalLimit').html('You can withdraw from your wallet <strong>unlimited</strong> requests daily with a charge of <strong>'+data.subscription.withdrawalFee+'%</strong> per withdrawal.');
            }
            $$('.cashbackTXT').html('You will get <strong>'+data.subscription.cashback+'%</strong> cashback on withdrawal charge after 45 days.');
          } else {
            app.toast.show({
              text: data.msg,
              closeTimeout: 3000,
            });
            //redirect to home page
            var view = app.views.current;
            view.router.navigate({name: 'Home'});
          }
        });
        //get ifsc
        $$('#ifsc').on('keyup', function() {
          if($$('#ifsc').val().length == 11) {
            app.preloader.show();
            $.getJSON('https://ifsc.razorpay.com/'+$$('#ifsc').val(), function(data) {app.preloader.hide();})
            .done(function(data) {
              app.preloader.hide();
              $$('#bankname').val(data.BANK);
              $$('.item-input-bank').addClass('item-input-focused');
              $$('.item-input-bank').addClass('item-input-with-value');
            })
            .fail(function() {
              app.preloader.hide();
              app.toast.show({
                text: 'Invalid IFSC code!',
                closeTimeout: 3000,
              });
            })
          }
        });
        //send a request to server to get last withdrawal details
        // app.methods.request(
        //   baseURL+'/app/php/lockers.php',
        //   {getLastWithdrawal: true, token: localStorage.getItem('authToken')},
        //   'json',
        //   function() { app.dialog.progress('Loading...'); },
        //   function(data) {
        //     app.dialog.close();
        //     if(data.status == 'success') {
        //       if(data.lastWithdrawal) {
        //         if(data.lastWithdrawal.feesStatus == '0') {
        //           //navigate to fees payment page
        //           setTimeout(() => {
        //             var view = app.views.current;
        //             view.router.navigate('/fees/transaction/'+data.lastWithdrawal.txnID);
        //             console.log('Fees not paid, redirecting to fees payment page.');
        //           }, 1000);
        //         }
        //       } else {
        //         console.log('No withdrawal details found.');
        //       }
        //     } else {
        //       app.toast.show({
        //         text: data.msg,
        //         closeTimeout: 3000,
        //       });
        //     }
        //   },
        //   function() {
        //     app.dialog.close();
        //     app.toast.show({
        //       text: 'No internet connection!',
        //       closeTimeout: 3000,
        //     });
        //   }
        // );
        //onkeyup of amount
        // $$('#amount').on('keyup', function() {
        //   var amount = $$('#amount').val();
        //   var wallet = $$('#wallet').val();
        //   // Numeric validation
        //   if (isNaN(amount) || amount === '' || parseFloat(amount) <= 0) {
        //     $$('.withdrawMoney').addClass('disabled');
        //     return;
        //   }
        //   if (parseFloat(amount) > parseFloat(wallet)) {
        //     $$('.withdrawMoney').addClass('disabled');
        //   } else {
        //     $$('.withdrawMoney').removeClass('disabled');
        //   }
        // });
        //submit withdrawal request
        $$('.withdrawMoney').on('click', function() {
          if (!$$('#transferMoney')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            withdrawMoney();
          }
        });
        function withdrawMoney() {
          var formdata = $('#transferMoney').serialize();
          var data = formdata+'&withdraw=true&token='+localStorage.getItem('authToken');
          app.methods.request(
            baseURL+'/app/php/lockers.php',
            data,
            'json',
            function() { app.dialog.progress('Loading...'); $$('.button').addClass('disabled'); },
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                app.popup.open('.sheet-loan--applied');
                $$('.sheet-loan--applied__title').html(INR2.format(data.amount)+' Withdrawal Requested!');
                $$('.sheet-loan--applied__text').html('Money will be transferred to your bank account once we verify your withdrawal, please wait while we\'re verifying your withdrawal.');
                var view = app.views.current;
                view.router.back('/',{force:true});
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        
        }
      }
    }
  },
  {
    path: '/money-transfer/',
    component: MoneyTransferPage,
    name: 'money-transfer',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        //get subscription details
        app.methods.getUserDataLocker(function(data) {
          app.dialog.close();
          if(data.status == 'success') {
            $$('.wallet--amount').html(INR2.format(data.subscription.wallet));
            $$('input[name="amount"]').attr('max', data.subscription.wallet);
            $$('input[name="wallet"]').val(data.subscription.wallet);
          } else {
            app.toast.show({
              text: data.msg,
              closeTimeout: 3000,
            });
            //redirect to home page
            var view = app.views.current;
            view.router.navigate({name: 'Home'});
          }
        });
        //on key up beneficiary phone
        // Prevent multiple event bindings on beneficiaryNumber input
        $$('#beneficiaryNumber').off('keyup');
        $$('#beneficiaryNumber').on('keyup', function() {
          var beneficiary = $$('#beneficiaryNumber').val();
          if(beneficiary.length == 10) {
            //validate it's a valid phone number
            if(!/^\d{10}$/.test(beneficiary)) {
              app.toast.show({
                text: 'Please enter a valid 10 digit phone number!',
                closeTimeout: 3000,
              });
              return;
            }
            //send request to server to validate beneficiary
            app.dialog.progress('Validating Beneficiary...');
            $.getJSON(baseURL+"app/php/lockers.php?validateBeneficiaryNumber=true&beneficiary="+beneficiary+"&token="+localStorage.getItem('authToken'), function() {
              app.dialog.close();
            })
            .done(function(data) {
              app.dialog.close();
              if(data.status == 'success') {
                $$('.beneficiaryDetails').empty();
                $$('.beneficiaryDetails').append('<div class="card card-main">\
                  <div class="card-content">\
                    <p class="text-color-red f-14"><b>Name: </b> '+data.userDetails.name+'</p>\
                  </div>\
                </div>');
                $$('#uid').val(data.userDetails.id);
                $$('.transferMoney').removeClass('disabled');
              } else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            })
            .fail(function() {
              app.dialog.close();
              app.toast.show({
                text: 'Something went wrong, please try again!',
                closeTimeout: 3000,
              });
            });
          }
        });
        //submit transfer request
        $$('.transferMoney').on('click', function() {
          if (!$$('#transferMoneyWallet')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            withdrawMoney();
          }
        });
        function withdrawMoney() {
          var formdata = $('#transferMoneyWallet').serialize();
          var data = formdata+'&transferMoneyWallet=true&token='+localStorage.getItem('authToken');
          app.methods.request(
            baseURL+'/app/php/lockers.php',
            data,
            'json',
            function() { app.dialog.progress('Loading...'); $$('.button').addClass('disabled'); },
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                app.popup.open('.sheet-loan--applied');
                $$('.sheet-loan--applied__title').html(INR2.format(data.amount)+' Money Transfer Successful!');
                $$('.sheet-loan--applied__text').html('Money has been transferred to wallet of '+data.receiverName+', your current wallet balance is '+INR2.format(data.walletBalance)+'.');
                var view = app.views.current;
                view.router.back('/',{force:true});
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        
        }
      }
    }
  },
  {
    path: '/transaction/:type',
    component: TransactionPage,
    name: TransactionPage,
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        var type = page.route.params.type;
        if(type == 'payment') {
          $$('.txn-title').html('Payment History');
        } else if(type == 'wallet') {
          $$('.txn-title').html('Transaction History');
        } else {
          $$('.txn-title').html('Withdrawal History');
        }
        app.dialog.progress('Loading...');
        //check if logged in or not
        app.methods.getUserData(
          function(data) {
            if(data.isLoggedin == 'true') {
              if(type == 'payment') {
                //get payment history
                $.getJSON(baseURL+"app/php/lockers.php?paymentHistory=true&token="+localStorage.getItem('authToken'), function() {
                  app.dialog.close();
                }
                )
                .done(function(data) {
                  app.dialog.close();
                  if(data.status == 'success') {
                    $$('.txn-history .list ul').empty();
                    $.each(data.paymentHistory, function(i, item) {
                      if(item.type == '1') {
                        var title = 'Payment for Subscription';
                      } else {
                        var title = 'Payment for Renewal';
                      }
                      if(item.status == '0') {
                        var status = 'Pending';
                        var statusColor = 'text-color-orange';
                        var img = 'assets/icons/pending.png';
                      } else if(item.status == '1') {
                        var status = 'Success';
                        var statusColor = 'text-color-green';
                        var img = 'assets/icons/checked.png';
                      } else {
                        var status = 'Failed';
                        var statusColor = 'text-color-red-deep';
                        var img = 'assets/icons/error.png';
                      }
                      $$('.txn-history .list ul').append('<li>\
                      <div class="item-content">\
                        <div class="item-media">\
                          <img src="'+img+'" height="40">\
                        </div>\
                        <div class="item-inner">\
                          <div class="item-title-row">\
                            <div class="item-title fw-600">'+title+'</div>\
                            <div class="item-after f-16 fw-600 text-color-blue">'+INR2.format(item.amount)+'</div>\
                          </div>\
                          <div class="item-subtitle f-12 fw-600 '+statusColor+'">'+status+'</div>\
                          <div class="item-text f-12">'+item.date+'</div>\
                        </div>\
                      </div>\
                    </li>');
                    });
                  } else {
                    app.toast.show({
                      text: data.msg,
                      closeTimeout: 3000,
                    });
                    $$('.txn-history').empty();
                    $$('.txn-history').append('<div class="text-align-center">\
                      <img src="assets/icons/no-data.png" height="70" style="margin-top: 125px;"/>\
                      <h3 class="text-color-blue f-16">No payment history found!</h3>\
                    </div>');
                  }
                })
                .fail(function() {
                  app.dialog.close();
                  app.toast.show({
                    text: 'Something went wrong, please try again!',
                    closeTimeout: 3000,
                  });
                });
              } else if(type == 'wallet') {
                  //get transaction history
                  $.getJSON(baseURL+"app/php/lockers.php?transactionHistory=true&token="+localStorage.getItem('authToken'), function() {
                    app.dialog.close();
                  }
                  )
                  .done(function(data) {
                    app.dialog.close();
                    if(data.status == 'success') {
                      $$('.txn-history .list ul').empty();
                      $.each(data.transactionHistory, function(i, item) {
                        if(item.type == '1') {
                          var title = 'Money Deposited';
                          var img = 'assets/icons/add-money.png';
                          var fee = '';
                          var amount = '<div class="item-after f-16 fw-600 text-color-green">+'+INR2.format(item.amount)+'</div>'
                        } else if(item.type == '2' && item.feeStatus == '0' && item.utr == '0') {
                          var title = 'Money Withdrawn';
                          var img = 'assets/icons/sent-money.png';
                          var fee = 'Withdrawal Fee: '+INR2.format(item.withdrawalFee)+' <span class="text-color-red-deep">Pending</span>\
                          <button class="button button-small button-fill bg-color-red button-gradient pay-fee-btn" data-txnid="'+item.txnID+'" style="width: 20%; height: 20px; margin-left: 10px; line-height: 1px">Pay Fee</button>';
                          var amount = '<div class="item-after f-16 fw-600 text-color-red-deep">-'+INR2.format(item.amount)+'</div>';
                        } else if(item.type == '2' && item.feeStatus == '0' && item.utr != '0') {
                          var title = 'Money Withdrawn';
                          var img = 'assets/icons/sent-money.png';
                          var fee = 'Withdrawal Fee: '+INR2.format(item.withdrawalFee)+' <span class="text-color-red-deep">Payment initiated</span>';
                          var amount = '<div class="item-after f-16 fw-600 text-color-red-deep">-'+INR2.format(item.amount)+'</div>';
                        } else if(item.type == '2' && item.feeStatus == '2' && item.utr != '0') {
                          var title = 'Money Withdrawn';
                          var img = 'assets/icons/sent-money.png';
                          var fee = 'Withdrawal Fee: '+INR2.format(item.withdrawalFee)+' <span class="text-color-red-deep">Rejected</span>\
                          <button class="button button-small button-fill bg-color-red button-gradient pay-fee-btn" data-txnid="'+item.txnID+'" style="width: 20%; height: 20px; margin-left: 10px; line-height: 1px">Pay Fee</button>';
                          var amount = '<div class="item-after f-16 fw-600 text-color-red-deep">-'+INR2.format(item.amount)+'</div>';
                        } else if(item.type == '2' && item.feeStatus == '1') {
                          var title = 'Money Withdrawn';
                          var img = 'assets/icons/sent-money.png';
                          var fee = 'Withdrawal Fee: '+INR2.format(item.withdrawalFee)+' <span class="text-color-green">Paid</span>';
                          var amount = '<div class="item-after f-16 fw-600 text-color-red-deep">-'+INR2.format(item.amount)+'</div>';
                        } else if(item.type == '3') {
                          var title = 'Money Refunded';
                          var img = 'assets/icons/refund.png';
                          var fee = '';
                          var amount = '<div class="item-after f-16 fw-600 text-color-green">+'+INR2.format(item.amount)+'</div>';
                        } else if(item.type == '4' && item.cashbackType == '1') {
                          var title = 'Welcome Bonus Received';
                          var img = 'assets/icons/cashback.png';
                          var fee = '';
                          var amount = '<div class="item-after f-16 fw-600 text-color-green">+'+INR2.format(item.amount)+'</div>';
                        } else if(item.type == '5') {
                          var title = 'Transferred to '+item.walletTransferUid;
                          var img = 'assets/icons/wallet-transfer.png';
                          var amount = '<div class="item-after f-16 fw-600 text-color-red-deep">-'+INR2.format(item.amount)+'</div>';
                          var fee = ''; 
                        } else if(item.type == '6') {
                          var title = 'Received from '+item.walletTransferUid;
                          var img = 'assets/icons/wallet-transfer.png';
                          var fee = '';
                          var amount = '<div class="item-after f-16 fw-600 text-color-green">+'+INR2.format(item.amount)+'</div>';
                        } else {
                          var title = 'Cashback Received';
                          var img = 'assets/icons/cashback.png';
                          var fee = '';
                          var amount = '<div class="item-after f-16 fw-600 text-color-green">+'+INR2.format(item.amount)+'</div>';
                        }
                        //status
                        if(item.status == '0') {
                          var status = 'Pending';
                          var statusColor = 'text-color-orange';
                          var remarks = '';
                        } else if(item.status == '1') {
                          var status = 'Success';
                          var statusColor = 'text-color-green';
                          var remarks = '';
                        } else {
                          var status = 'Failed';
                          var statusColor = 'text-color-red-deep';
                          var remarks = item.remarks;
                        }
                        $$('.txn-history .list ul').append('<li>\
                        <div class="item-content">\
                          <div class="item-media">\
                            <img src="'+img+'" height="40">\
                          </div>\
                          <div class="item-inner">\
                            <div class="item-title-row">\
                              <div class="item-title fw-600">'+title+'</div>\
                              '+amount+'\
                            </div>\
                            <div class="item-subtitle f-12 fw-600 '+statusColor+'">'+status+'</div>\
                            <div class="item-text f-12">Closing Balance: '+INR2.format(item.updatedBalance)+'</div>\
                            <div class="item-text f-12">'+fee+'</div>\
                            <div class="item-text f-12">'+item.date+'</div>\
                            <div class="item-text f-12 fw-600 '+statusColor+'">'+remarks+'</div>\
                          </div>\
                        </div>\
                      </li>');
                      });
                    } else {
                      $$('.txn-history').empty();
                      $$('.txn-history').append('<div class="text-align-center">\
                        <img src="assets/icons/no-data.png" height="70" style="margin-top: 125px;"/>\
                        <h3 class="text-color-blue f-16">No transaction history found!</h3>\
                      </div>');
                    }
                })
                .fail(function() {
                  app.dialog.close();
                  app.toast.show({
                    text: 'Something went wrong, please try again!',
                    closeTimeout: 3000,
                  });
                });
              } else {
                //get withdrawal history for investments
                $.post(baseURL+"app/php/invest.php", {withdrawalHistory:true,token:localStorage.getItem('authToken')}, function() {
                  app.dialog.close();
                }).
                done(function(data) {
                  app.dialog.close();
                  if(data.status == 'success') {
                    $$('.txn-history .list ul').empty();
                    if(typeof data.withdrawHistory == 'undefined' || data.withdrawHistory.length == 0) {
                      $$('.txn-history').empty();
                      $$('.txn-history').append('<div class="text-align-center">\
                        <img src="assets/icons/no-data.png" height="70" style="margin-top: 125px;"/>\
                        <h3 class="text-color">No return history found!</h3>\
                      </div>');
                    } else {
                      $.each(data.withdrawHistory, function(i, item) {
                        var img = 'assets/icons/sent-money.png';
                        var title = 'Money Withdrawn';
                        //status
                        if(item.status == '0') {
                          var status = 'Pending';
                          var statusColor = 'text-color-orange';
                          var remarks = '';
                        } else if(item.status == '1') {
                          var status = 'Success';
                          var statusColor = 'text-color-green';
                          var remarks = '';
                        } else {
                          var status = 'Failed';
                          var statusColor = 'text-color-red-deep';
                          var remarks = item.remarks;
                        }
                        $$('.txn-history .list ul').append('<li>\
                        <div class="item-content">\
                          <div class="item-media">\
                            <img src="'+img+'" height="40">\
                          </div>\
                          <div class="item-inner">\
                            <div class="item-title-row">\
                              <div class="item-title fw-600">'+title+'</div>\
                              <div class="item-after f-16 fw-600 text-color-blue">'+INR2.format(item.amount)+'</div>\
                            </div>\
                            <div class="item-text f-12">'+item.investID+'</div>\
                            <div class="item-subtitle f-12 fw-600 '+statusColor+'">'+status+'</div>\
                            <div class="item-text f-12">Closing Balance: '+INR2.format(item.updatedBalance)+'</div>\
                            <div class="item-text f-12">'+item.date+'</div>\
                            <div class="item-text f-12 fw-600 '+statusColor+'">'+remarks+'</div>\
                          </div>\
                        </div>\
                      </li>');
                      });
                    }
                  } else {
                    $$('.txn-history').empty();
                    $$('.txn-history').append('<div class="text-align-center">\
                      <img src="assets/icons/no-data.png" height="70" style="margin-top: 125px;"/>\
                      <h3 class="text-color-blue f-16">No transaction history found!</h3>\
                    </div>');
                  }
                })
                .fail(function() {
                  app.dialog.close();
                  app.toast.show({
                    text: 'Something went wrong, please try again!',
                    closeTimeout: 3000,
                  });
                });
              }
              // Handle Pay Fee button click
              $(document).on('click', '.pay-fee-btn', function() {
                var txnID = $$(this).attr('data-txnid');
                var view = app.views.current;
                view.router.navigate('/fees/transaction/' + txnID);
              });
            } else {
              app.dialog.close();
              app.views.main.router.navigate({name: 'Home'});
            }
        });
      }
    }
  },
  {
    path: '/invest/',
    component: InvestPage,
    name: 'invest',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        // initialize box-scope
        var boxes = document.querySelectorAll('.box');

        for(let i = 0; i < boxes.length; i++) {
          let box = boxes[i];
          app.methods.initDropEffect(box);
          app.methods.initImageUpload(box);
        }
        app.methods.initFileUpload();
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(data) {
          if(data.isLoggedin == 'true') {
            app.dialog.close();
            $$('.profile-link').attr('href','#');
            $$('.profile-link').addClass('popup-open');
            $$('.profile-link').attr('data-popup','#profile-popup');
          } else {
            app.dialog.close();
            app.views.main.router.navigate({name: 'Home'});
          }
        });
        //get investment details
        app.methods.getUserDataInvest(function(data) {
          var goldRate = data.goldRate;
          var goldRatewithGST = +goldRate + +(goldRate * 0.03); // adding 3% GST
          goldRatewithGST = goldRatewithGST.toFixed(0);
          if(goldRate) {
            $$('.gold-price__today').html(INR.format(goldRate)+'/gm');
            $$('.gold-price__today').data('goldrate', goldRate);
            // default input value is 2.1k
            var defaultAmount = 2100;
            var buyConvertedValue = (defaultAmount / goldRate).toFixed(3);
            $$('.buy-converted-value').html(buyConvertedValue+' gm');
            // on key up of amount input
            $$('.buy-amount-input').on('keyup', function() {
              var amount = $$('.buy-amount-input').val();
              if(isNaN(amount) || amount <= 0) {
                $$('.buy-converted-value').html('0 gm');
                return;
              }
              var convertedValue = (amount / goldRate).toFixed(3);
              $$('.buy-converted-value').html(convertedValue+' gm');
            });
          }
          if(data.status == 'success') {
            $$('.gold-balance').html(data.wallet + ' gm');
            $$('.vault__link').attr('href','/invest-dashboard/');
            $.each(data.data, function (i, item) {
              //check if last investment status is 0
              if(item.status == '0') {
                $$('.buy__digital-gold').addClass('disabled');
                app.toast.show({
                  text: 'Your last investment is still being processed. You cannot make a new investment until the previous one is completed.',
                  closeTimeout: 5000,
                });
                return false; // break the loop
              }
              var payableMoney = Number(data && data.payableMoney);
              if (Number.isFinite(payableMoney) && payableMoney > 0) {
                $$('.buy-amount-input').val(payableMoney);
                $$('.buy-amount-input').attr('readonly', true);
                $$('.buy-amount-input').trigger('keyup');
                // disable quick-chip clicks events
                $$('.quick-chip').off('click');
              }
            });
          } else {
            var payableMoney = Number(data && data.payableMoney);
            if (Number.isFinite(payableMoney) && payableMoney > 0) {
              $$('.buy-amount-input').val(payableMoney);
              $$('.buy-amount-input').attr('readonly', true);
              $$('.buy-amount-input').trigger('keyup');
              // disable quick-chip clicks events
              $$('.quick-chip').off('click');
            } else {
              // $$('.buy-amount-input').val('2150');
              // $$('.buy-amount-input').attr('readonly', true);
              // $$('.buy-amount-input').trigger('keyup');
            }
            $$('.gold-balance').html('0 gm');
            $$('.vault__link').attr('href','#');
          }
        });
        // create a count down to next day 10:00 AM
        function updateCountdown() {
          var now = new Date();
          var nextDay = new Date();
          nextDay.setDate(now.getDate() + 1);
          nextDay.setHours(10, 0, 0, 0); // Set to 10:00 AM next day
          var distance = nextDay - now;

          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          $$('.countdown-timer').html(hours + 'h ' + minutes + 'm ' + seconds + 's ');

          if (distance < 0) {
            clearInterval(countdownInterval);
            $$('.countdown-timer').html(hours + 'h ' + minutes + 'm ' + seconds + 's ');
          }
        }
        // Update the countdown every second
        var countdownInterval = setInterval(updateCountdown, 1000);
        updateCountdown(); // Initial call to display immediately
        // add amount in input by click on quick-chip
        $$('.quick-chip').on('click', function() {
          var chipAmount = parseInt($$(this).attr('data-add'));
          var currentAmount = parseInt($$('.buy-amount-input').val()) || 0;
          var newAmount = currentAmount + chipAmount;
          $$('.buy-amount-input').val(newAmount);
          // Trigger keyup event to update converted value
          $$('.buy-amount-input').trigger('keyup');
        });
        function renderInvestBankDetails(payableAmount) {
          $$('.getBankdet').empty();
          app.methods.getBank(function(data) {
            $$('.getBankdet').empty();
            app.dialog.close();

            var numericPayable = Number(payableAmount);
            var upiAmount = (Number.isFinite(numericPayable) && numericPayable > 0) ? numericPayable.toFixed(2) : '';

            if(data.isUPI == '1' && data.isBank == '1') {
              // reuqired data for UPI button
              var upiID = data.upi_id;
              var upiName = data.beneficiary;
              var upiNote = "Digital Gold Investment";
              var upiURL = "upi://pay?pa=" + encodeURIComponent(upiID) +
                           "&pn=" + encodeURIComponent(upiName) +
                           "&tn=" + encodeURIComponent(upiNote) +
                           "&am=" + encodeURIComponent(upiAmount) +
                           "&cu=INR";
              // IMPORTANT: Do not HTML-escape '&' when setting href via DOM APIs, otherwise UPI apps may not parse params like `am`
              var upiHref = upiURL;
              // Use Cordova _system when available, otherwise fall back to _blank (web)
              var upiTarget = (typeof window !== 'undefined' && window.cordova) ? '_system' : '_blank';

              var upiBtnClass = upiAmount ? 'link external button button-large button-fill bg-color-green button-gradient' : 'link button button-large button-fill disabled';
              var upiBtnHref = upiAmount ? upiHref : '#';

              $$('#payWithUpiBtn').attr('href', upiBtnHref).attr('target', upiTarget).removeClass('disabled').addClass(upiBtnClass);

              //upi-app-shortcut links for popular UPI apps data-upi-app as filter
                // upi-app-shortcut links for popular UPI apps (Android intent deep links)
                $$('.upi-app-shortcut').each(function () {
                var $el = $$(this);
                var upiApp = ($el.data('upi-app') || '').toString().toLowerCase();

                // Android package names for intents
                var packageMap = {
                  gpay: 'com.google.android.apps.nbu.paisa.user',
                  phonepe: 'com.phonepe.app',
                  paytm: 'net.one97.paytm',
                };

                var isAndroid =
                  typeof window !== 'undefined' &&
                  window.cordova &&
                  window.device &&
                  (window.device.platform || '').toString().toLowerCase() === 'android';

                // If amount isn't available/valid, disable shortcut
                if (!upiAmount) {
                  $el.attr('href', '#').addClass('disabled').removeAttr('target');
                  return;
                }

                // Default to generic UPI link
                var finalHref = upiURL;

                // Use intent URLs on Android to open specific app
                if (isAndroid) {
                  var pkg = packageMap[upiApp];
                  var intentPath = upiURL.replace(/^upi:\/\//, ''); // "pay?pa=..."
                  if (pkg) {
                  finalHref =
                    'intent://' +
                    intentPath +
                    '#Intent;scheme=upi;package=' +
                    pkg +
                    ';end';
                  } else {
                  // fallback generic intent (no package)
                  finalHref = 'intent://' + intentPath + '#Intent;scheme=upi;end';
                  }
                }

                // Set the URL as-is (no '&amp;') so apps can parse `am`
                $el.removeClass('disabled').attr('href', finalHref).attr('target', upiTarget);
                });

              $$('.getBankdet').append('<div class="block-payment">\
              <div class="card-content" style="padding: 14px 14px 10px;">\
                <div class="text-color-red f-12" style="letter-spacing: .06em; text-transform: uppercase;">\
                Account Details\
                </div>\
                <div class="list list__loanst">\
                <ul style="background: transparent;">\
                <li>\
                <div class="item-content">\
                  <div class="item-inner">\
                  <div class="item-title text-color-gray f-12"> Beneficiary </div>\
                  <div class="item-after text-color-white fw-600">'+data.beneficiary+'</div>\
                  <a href="#" class="copy-icon" data-copy="'+data.beneficiary+'" style="margin-left:8px;"><img src="assets/icons/copy.png" width="16" height="16" alt="Copy" style="filter: brightness(0) saturate(100%) invert(79%) sepia(33%) saturate(747%) hue-rotate(4deg) brightness(92%) contrast(90%);"></a>\
                  </div>\
                </div>\
                </li>\
                <li style="height:1px; background: rgba(255,255,255,0.08); margin: 0;"></li>\
                <li>\
                <div class="item-content">\
                  <div class="item-inner">\
                  <div class="item-title text-color-gray f-12">Bank Name</div>\
                  <div class="item-after text-color-white fw-600">'+data.acc_name+'</div>\
                  <a href="#" class="copy-icon" data-copy="'+data.acc_name+'" style="margin-left:8px;"><img src="assets/icons/copy.png" width="16" height="16" alt="Copy" style="filter: brightness(0) saturate(100%) invert(79%) sepia(33%) saturate(747%) hue-rotate(4deg) brightness(92%) contrast(90%);"></a>\
                  </div>\
                </div>\
                </li>\
                <li style="height:1px; background: rgba(255,255,255,0.08); margin: 0;"></li>\
                <li>\
                <div class="item-content">\
                  <div class="item-inner">\
                  <div class="item-title text-color-gray f-12">Account Number</div>\
                  <div class="item-after text-color-white fw-600">'+data.acc_num+' \
                  <a href="#" class="copy-icon" data-copy="'+data.acc_num+'" style="margin-left:8px;"><img src="assets/icons/copy.png" width="16" height="16" alt="Copy" style="filter: brightness(0) saturate(100%) invert(79%) sepia(33%) saturate(747%) hue-rotate(4deg) brightness(92%) contrast(90%);"></a>\
                  </div>\
                  </div>\
                </div>\
                </li>\
                <li style="height:1px; background: rgba(255,255,255,0.08); margin: 0;"></li>\
                <li>\
                <div class="item-content">\
                  <div class="item-inner">\
                  <div class="item-title text-color-gray f-12">IFSC Code</div>\
                  <div class="item-after text-color-white fw-600">'+data.acc_ifsc+' \
                  <a href="#" class="copy-icon" data-copy="'+data.acc_ifsc+'" style="margin-left:8px;"><img src="assets/icons/copy.png" width="16" height="16" alt="Copy" style="filter: brightness(0) saturate(100%) invert(79%) sepia(33%) saturate(747%) hue-rotate(4deg) brightness(92%) contrast(90%);"></a>\
                  </div>\
                  </div>\
                </div>\
                </li>\
                </ul>\
                </div>\
                <div class="credit-list creditStore text-align-center">\
                  <div class="block text-align-center">\
                    <img src="https://vyoorajewels.com/'+data.upi_qrIMG+'" width="150" style="margin-top: 25px;"/>\
                    <div class="item-title text-color-white fw-600"><b>UPI ID: '+data.upi_id+' \
                      <a href="#" class="copy-icon" data-copy="'+data.upi_id+'" style="margin-left:8px;"><img src="assets/icons/copy.png" width="16" height="16" alt="Copy" style="filter: brightness(0) saturate(100%) invert(79%) sepia(33%) saturate(747%) hue-rotate(4deg) brightness(92%) contrast(90%);"></a>\
                    </b></div>\
                  </div>\
                </div>\
              </div>\
              </div>');
            } else if(data.isUPI == '1' && data.isBank == '0') {
              // reuqired data for UPI button
              var upiID = data.upi_id;
              var upiName = data.beneficiary;
              var upiNote = "Digital Gold Investment";
              var upiURL = "upi://pay?pa=" + encodeURIComponent(upiID) +
                           "&pn=" + encodeURIComponent(upiName) +
                           "&tn=" + encodeURIComponent(upiNote) +
                           "&am=" + encodeURIComponent(upiAmount) +
                           "&cu=INR";
              // Escape & to avoid HTML entity parsing issues when injecting into string HTML
              var upiHref = upiURL.replace(/&/g, '&amp;');
              // Use Cordova _system when available, otherwise fall back to _blank (web)
              var upiTarget = (typeof window !== 'undefined' && window.cordova) ? '_system' : '_blank';

              var upiBtnClass = upiAmount ? 'link external button button-large button-fill bg-color-green button-gradient' : 'link button button-large button-fill disabled';
              var upiBtnHref = upiAmount ? upiHref : '#';

              $$('#payWithUpiBtn').attr('href', upiBtnHref).attr('target', upiTarget).removeClass('disabled').addClass(upiBtnClass);

              //upi-app-shortcut links for popular UPI apps data-upi-app as filter
                // upi-app-shortcut links for popular UPI apps (Android intent deep links)
                $$('.upi-app-shortcut').each(function () {
                var $el = $$(this);
                var app = ($el.data('upi-app') || '').toString().toLowerCase();

                // Android package names for intents
                var packageMap = {
                  gpay: 'com.google.android.apps.nbu.paisa.user',
                  phonepe: 'com.phonepe.app',
                  paytm: 'net.one97.paytm',
                };

                var isAndroid =
                  typeof window !== 'undefined' &&
                  window.cordova &&
                  window.device &&
                  (window.device.platform || '').toString().toLowerCase() === 'android';

                // If amount isn't available/valid, disable shortcut
                if (!upiAmount) {
                  $el.attr('href', '#').addClass('disabled');
                  return;
                }

                // Default to generic UPI link
                var finalHref = upiURL;

                // Use intent URLs on Android to open specific app
                if (isAndroid) {
                  var pkg = packageMap[app];
                  var intentPath = upiURL.replace(/^upi:\/\//, ''); // "pay?pa=..."
                  if (pkg) {
                  finalHref =
                    'intent://' +
                    intentPath +
                    '#Intent;scheme=upi;package=' +
                    pkg +
                    ';end';
                  } else {
                  // fallback generic intent (no package)
                  finalHref = 'intent://' + intentPath + '#Intent;scheme=upi;end';
                  }
                }

                // Avoid HTML entity parsing issues when injecting into string HTML
                var safeHref = finalHref.replace(/&/g, '&amp;');
                $el.attr('href', safeHref).attr('target', upiTarget);
                });
              $$('.getBankdet').append('<div class="block-payment">\
                <div class="card-content" style="padding: 14px 14px 10px;">\
                  <div class="credit-list creditStore text-align-center">\
                  <div class="block text-align-center">\
                    <img src="https://vyoorajewels.com/'+data.upi_qrIMG+'" width="150" style="margin-top: 25px;"/>\
                    <div class="item-title text-color-white fw-600"><b>UPI ID: '+data.upi_id+' \
                      <a href="#" class="copy-icon" data-copy="'+data.upi_id+'" style="margin-left:8px;"><img src="assets/icons/copy.png" width="16" height="16" alt="Copy" style="filter: brightness(0) saturate(100%) invert(79%) sepia(33%) saturate(747%) hue-rotate(4deg) brightness(92%) contrast(90%);"></a>\
                    </b></div>\
                    </div>\
                  </div>\
                </div>\
              </div>');
            } else if(data.isUPI == '0' && data.isBank == '1') {
              $$('.block-container-upi').empty();
              $$('.getBankdet').append('<div class="block-payment">\
              <div class="card-content" style="padding: 14px 14px 10px;">\
                <div class="list list__loanst">\
                  <ul style="background: transparent;">\
                    <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                      <div class="item-title text-color-gray f-12"> Beneficiary </div>\
                      <div class="item-after text-color-white fw-600">'+data.beneficiary+'</div>\
                      <a href="#" class="copy-icon" data-copy="'+data.beneficiary+'" style="margin-left:8px;"><img src="assets/icons/copy.png" width="16" height="16" alt="Copy" style="filter: brightness(0) saturate(100%) invert(79%) sepia(33%) saturate(747%) hue-rotate(4deg) brightness(92%) contrast(90%);"></a>\
                      </div>\
                    </div>\
                    </li>\
                    <li style="height:1px; background: rgba(255,255,255,0.08); margin: 0;"></li>\
                    <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                      <div class="item-title text-color-gray f-12">Bank Name</div>\
                      <div class="item-after text-color-white fw-600">'+data.acc_name+'</div>\
                      <a href="#" class="copy-icon" data-copy="'+data.acc_name+'" style="margin-left:8px;"><img src="assets/icons/copy.png" width="16" height="16" alt="Copy" style="filter: brightness(0) saturate(100%) invert(79%) sepia(33%) saturate(747%) hue-rotate(4deg) brightness(92%) contrast(90%);"></a>\
                      </div>\
                    </div>\
                    </li>\
                    <li style="height:1px; background: rgba(255,255,255,0.08); margin: 0;"></li>\
                    <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                      <div class="item-title text-color-gray f-12">Account Number</div>\
                      <div class="item-after text-color-white fw-600">'+data.acc_num+' \
                      <a href="#" class="copy-icon" data-copy="'+data.acc_num+'" style="margin-left:8px;"><img src="assets/icons/copy.png" width="16" height="16" alt="Copy" style="filter: brightness(0) saturate(100%) invert(79%) sepia(33%) saturate(747%) hue-rotate(4deg) brightness(92%) contrast(90%);"></a>\
                      </div>\
                      </div>\
                    </div>\
                    </li>\
                    <li style="height:1px; background: rgba(255,255,255,0.08); margin: 0;"></li>\
                    <li>\
                    <div class="item-content">\
                      <div class="item-inner">\
                      <div class="item-title text-color-gray f-12">IFSC Code</div>\
                      <div class="item-after text-color-white fw-600">'+data.acc_ifsc+' \
                      <a href="#" class="copy-icon" data-copy="'+data.acc_ifsc+'" style="margin-left:8px;"><img src="assets/icons/copy.png" width="16" height="16" alt="Copy" style="filter: brightness(0) saturate(100%) invert(79%) sepia(33%) saturate(747%) hue-rotate(4deg) brightness(92%) contrast(90%);"></a>\
                      </div>\
                      </div>\
                    </div>\
                    </li>\
                  </ul>\
                </div>\
              </div>\
            </div>');
            } else {
              $$('.getBankdet').empty();
              console.log('No bank details found.');
            }

            // Copy to clipboard handler
            $$(document).off('click', '.copy-icon');
            $$(document).on('click', '.copy-icon', function(e) {
              e.preventDefault();
              var text = $$(this).attr('data-copy');
              if (navigator && navigator.clipboard) {
              navigator.clipboard.writeText(text).then(function() {
                app.toast.show({text: 'Copied!', closeTimeout: 1500});
              });
              } else {
              // fallback for older browsers
              var tempInput = document.createElement('input');
              tempInput.value = text;
              document.body.appendChild(tempInput);
              tempInput.select();
              document.execCommand('copy');
              document.body.removeChild(tempInput);
              app.toast.show({text: 'Copied!', closeTimeout: 1500});
              }
            });
          });
        }

        // on click of buy digital gold button
        $$('.buy__digital-gold').on('click', function() {
          // condition if amount is 10 to 100000
          var amount = $$('.buy-amount-input').val();
          if(isNaN(amount) || amount < 10 || amount > 100000) {
            app.toast.show({
              text: 'Please enter a valid amount between ₹10 and ₹1,00,000',
              closeTimeout: 3000,
            });
            return;
          }
          var investAmount = amount;
          app.popup.open('.sheet--invest-payment');
          $$('.investAmount').html(INR2.format(investAmount));
          var goldRate = $$('.gold-price__today').data('goldrate');
          var goldValue = (investAmount / goldRate).toFixed(3);
          // add extra 10% promotional gold
          var promotionalGold = (goldValue * 0.10).toFixed(3);
          $$('.goldValue').html((parseFloat(goldValue) + parseFloat(promotionalGold)).toFixed(3) + ' gm');
          var payableAmount = (+investAmount) + (+investAmount * 0.03); // adding 3% GST
          payableAmount = Number(payableAmount.toFixed(2));
          $$('.payableAmount').html(INR2.format(payableAmount));
          $$('#investPaymentAmount').val(investAmount);
          $$('#goldQty').val((parseFloat(goldValue) + parseFloat(promotionalGold)).toFixed(3));
          $$('#goldRates').val(goldRate);

          // Render bank/UPI section using the fresh computed payableAmount (prevents wrong/stale value)
          renderInvestBankDetails(payableAmount);
        });
        //js-paste-utr paste UTR number from clipboard
        $$('.js-paste-utr').on('click', function() {
          if (navigator && navigator.clipboard) {
            navigator.clipboard.readText().then(function(text) {
              $$('#utr-invest').val(text);
            });
          }
        });
        //upload payment for investment
        $$('.submitInvest').on('click', function() {
          var paymentIMG = $$('#paymentReceipt').prop('files')[0];
          var utr = $$('#utr-invest').val();
          var formData = new FormData();
          formData.append('submitInvest', true);
          formData.append('token', localStorage.getItem('authToken'));
          formData.append('paymentIMG', paymentIMG);
          formData.append('utr', utr);
          formData.append('amount', $$('#investPaymentAmount').val());
          formData.append('goldQty', $$('#goldQty').val());
          formData.append('goldRates', $$('#goldRates').val());
          if(!$$('#investPaymentAmount')[0].checkValidity()) {
            app.toast.show({
              text: 'Please enter your investment amount!',
              closeTimeout: 3000,
            });
          }
          else if(!$$('#utr-invest')[0].checkValidity()) {
            app.toast.show({
              text: 'Please enter your UTR number!',
              closeTimeout: 3000,
            });
          }
          else if(!$$('#paymentReceipt')[0].checkValidity()) {
            app.toast.show({
              text: 'Please upload your payment receipt!',
              closeTimeout: 3000,
            });
          }
          else {
            var file = $$('#paymentReceipt').prop('files')[0];
            var fileType = file['type'];
            var validImageTypes = ["image/gif", "image/jpeg", "image/png", "image/jpg"];
            if ($.inArray(fileType, validImageTypes) < 0) {
              app.toast.show({
                text: 'This is not an image, please upload an image!',
                closeTimeout: 3000,
              });
            } else {
              app.methods.post(
                baseURL+'app/php/invest.php',
                formData,
                'json',
                function() {
                  app.dialog.progress('Loading...');
                },
                function(data) {
                  app.dialog.close();
                  if(data.status == 'success') {
                    //close all popups
                    app.popup.close('.sheet--invest-payment');
                    app.popup.open('.sheet-loan--applied');
                    var view = app.views.current;
                    view.router.navigate('/invest-dashboard/');
                  }
                  else {
                    app.toast.show({
                      text: data.msg,
                      closeTimeout: 3000,
                    });
                  }
                },
                function() {
                  app.dialog.close();
                  app.toast.show({
                  text: 'Something went wrong, please try again!',
                  closeTimeout: 3000,
                });
                }
              );
            }
          }
        });
      }
    }
  },
  {
    path: '/invest-dashboard/',
    component: InvestDashboardPage,
    name: 'invest-dashboard',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(data) {
          if(data.isLoggedin == 'true') {
            app.dialog.close();
            $$('.profile-link').attr('href','#');
            $$('.profile-link').addClass('popup-open');
            $$('.profile-link').attr('data-popup','#profile-popup');
            $$('.referral-code').html(data.referralCode);
            $$('.invite-link-btn').attr('data-referral', data.referralCode);
          } else {
            app.dialog.close();
            app.views.main.router.navigate({name: 'Home'});
          }
        });
        //copy-icon copy referral code
        $$('.copy-icon').on('click', function(e) {
          e.preventDefault();
          var text = $$('.referral-code').text();
          if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(text).then(function() {
              app.toast.show({text: 'Copied!', closeTimeout: 1500});
            });
          } else {
            // fallback for older browsers
            var tempInput = document.createElement('input');
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
            app.toast.show({text: 'Copied!', closeTimeout: 1500});
          }
        });
        $$('.invite-link-btn').on('click', function() {
          var shareLink = 'https://app.vyoorajewels.com/#!/register/referral/' + $$(this).attr('data-referral');
          if (navigator.share) {
            navigator.share({
              title: 'Join YouPayWallet',
              text: 'Use my referral code to join YouPayWallet!',
              url: '' + shareLink
            }).catch(() => {});
          } else {
            console.log('Web Share API not supported in this browser.');
            //copy the link to clipboard
            if (navigator && navigator.clipboard) {
              navigator.clipboard.writeText(shareLink).then(function() {
                app.toast.show({text: 'Invitation link copied to clipboard!', closeTimeout: 1500});
              });
            }
          }
        });
        //get investment details
        app.methods.getUserDataInvest(function(data) {
          if(data.status == 'success') {
            //each function
            $$('.all-invest--list ul').empty();
            $.each(data.data, function (i, item) {
              var status, statusColor, badgeBg, img;

              // normalize dates (strip time if present)
              var investedDate = (item.date || '').toString().split(' ')[0];
              var activatedDate = (item.dateStart || investedDate || '').toString().split(' ')[0];
              var closingDate = (item.dateExpire || '').toString().split(' ')[0];

              if (item.status == '0') {
              status = 'Processing';
              statusColor = 'text-color-orange';
              badgeBg = 'rgba(255, 159, 10, 0.18)';
              img = 'https://cdn-icons-png.flaticon.com/512/15092/15092613.png';
              } else if (item.status == '1') {
              status = 'Active';
              statusColor = 'text-color-green';
              badgeBg = 'rgba(52, 199, 89, 0.16)';
              img = 'assets/icons/profit.gif';
              } else {
              status = 'Rejected';
              statusColor = 'text-color-red-deep';
              badgeBg = 'rgba(255, 69, 58, 0.16)';
              img = 'assets/icons/error.png';
              }

              // meta line shown in card (fixes unused `date`/`dateExpire` warnings)
              var metaLine = '';
              if (item.status == '0') metaLine = investedDate ? `Invested on ${investedDate}` : '';
              if (item.status == '1') metaLine = activatedDate ? `Activated on ${activatedDate}${closingDate ? ` • Closes on ${closingDate}` : ''}` : '';
              if (item.status == '2') metaLine = closingDate ? `Rejected on ${closingDate}` : '';
              $$('.all-invest--list ul').append(`
              <li style="margin: 10px 0;">
                <a href="#"
                 class="item-link item-content item-investment"
                 data-id="${item.investID}"
                 style="
                   display:flex;
                   gap:12px;
                   padding:14px;
                   border-radius:14px;
                   background: rgba(255,255,255,0.06);
                   border: 1px solid rgba(255,255,255,0.10);
                   backdrop-filter: blur(6px);
                   -webkit-backdrop-filter: blur(6px);
                 ">
                <div class="item-media" style="
                  width:44px;height:44px;min-width:44px;
                  border-radius:12px;
                  display:flex;align-items:center;justify-content:center;
                  background: rgba(255,255,255,0.06);
                  border: 1px solid rgba(255,255,255,0.08);
                  overflow:hidden;">
                  <img src="${img}" width="28" height="28" style="object-fit:contain;" />
                </div>

                <div class="item-inner" style="padding:0;">
                  <div style="display:flex; align-items:flex-start; justify-content:space-between; gap:10px;">
                  <div class="text-color-white fw-600" style="font-size:14px; line-height:1.2;">
                    Invested: ${INR.format(item.amount)} <br/> QTY: ${item.goldQTY} gm
                  </div>

                  <div class="${statusColor} fw-600" style="
                    font-size:12px;
                    padding:4px 10px;
                    border-radius:999px;
                    background:${badgeBg};
                    border: 1px solid rgba(255,255,255,0.10);
                    white-space:nowrap;">
                    ${status}
                  </div>
                  </div>

                  <div class="text-color-gray" style="margin-top:6px; font-size:12px; opacity:.9;">
                  Ref ID: <span class="text-color-white fw-600">#${item.investID}</span>
                  ${metaLine ? `<span style="margin-left:8px;">• ${metaLine}</span>` : ''}
                  </div>
                </div>
                </a>
              </li>
              `);

              //check in this each loop if first item is closed or not
              if (i == 0) {
              if (item.status == '1') {
                $$('.card__sell-action').removeClass('hidden');
              } else {
                $$('.card__sell-action').addClass('hidden');
              }
              }
            });
            $$('.gold-price').html(INR2.format(data.goldRate));
            //calculate gold quantity, gold price is in for 1 grams
            var goldQuantity = (data.wallet / data.goldRate) * 1;
            $$('.gold-quantity').html(parseFloat(goldQuantity).toFixed(2) + ' Grams');
            //set wallet amount
            $$('.invest__wallet--amount').html(
              (data.wallet) + 
              ' <span style="font-size: 14px;">(' +INR2.format(data.wallet * data.goldRate) + ')</span>'
            );
            $$('.item_link--returns').attr('href', '/returns/');
            $$('.item__link--withdraw').attr('href', '/invest-withdraw/');
            $$('.item__link--history').attr('href', '/transaction/investment');
          } else {
            //redirect to home page
            var view = app.views.current;
            view.router.navigate({name: 'Home'});
          }
        });
        $$(document).on('click', '.no-invest__toast', function() {
          app.toast.show({
            text: 'You can\'t invest now, please wait for until your current investment is closed!',
            closeTimeout: 3000,
          });
        });
        $(document).off('click', '.item-investment');
        $(document).on('click', '.item-investment', function(e) {
          app.preloader.show();
          e.preventDefault();
          var investID = $(this).attr('data-id');
          if (!investID) {
            app.toast.show({
              text: 'Investment ID not found!',
              closeTimeout: 3000,
            });
            return;
          }
          app.methods.getUserDataInvest(function(data) {
            if (data.status == 'success') {
              app.preloader.hide();
              var itemData = data.data.find(item => item.investID === investID);
              if(itemData.status == '0') {
                var status = 'Processing';
                var statusColor = 'text-color-orange';
              } else if(itemData.status == '1') {
                var status = 'Active';
                var statusColor = 'text-color-green';
              } else {
                var status = 'Rejected';
                var statusColor = 'text-color-red-deep';
              }
              if (itemData.date && typeof itemData.date === 'string') {
                // Remove time part if present (e.g. "2024-06-10 12:34:56" => "2024-06-10")
                itemData.date = itemData.date.split(' ')[0];
              }
              itemData.amount = INR2.format(itemData.amount);
              itemData.estimatedReturn = INR2.format(itemData.estimatedReturn);
              itemData.dailyReturn = INR2.format(itemData.dailyReturn);
              if(itemData.withdrawn > 0) {
                var goldDelivery = 'Not-Eligible';
                var goldDeliveryClass = 'text-color-red-deep';
              } else {
                var goldDelivery = 'Eligible After '+itemData.halfwayDate;
                var goldDeliveryClass = 'text-color-green';
              }
              itemData.withdrawn = itemData.withdrawn > 0 ? INR2.format(itemData.withdrawn) : 'N/A';
              if (!itemData) {
                app.toast.show({
                  text: 'Investment details not found!',
                  closeTimeout: 3000,
                });
                return;
              }
                const showInvoiceBtn = String(itemData.status) === '1';

                var detailsSheet = app.sheet.create({
                  content: `
                  <div
                  class="sheet-modal sheet-investment-details"
                  style="
                  height:auto;
                  color:#fff;
                  border-radius:18px;
                  border: 1px solid transparent;
                  background:
                    linear-gradient(#070B16, #070B16) padding-box,
                    linear-gradient(135deg, #FFF2B0 0%, #F7D774 20%, #D4AF37 55%, #B8860B 100%) border-box;
                  box-shadow:
                    0 18px 50px rgba(0,0,0,0.65),
                    0 0 0 1px rgba(212,175,55,0.20) inset,
                    0 0 28px rgba(212,175,55,0.12);
                  overflow:hidden;
                  "
                  >
                  <div
                  class="toolbar"
                  style="
                    background: transparent !important;
                    border-bottom:1px solid rgba(212,175,55,0.22);
                  "
                  >
                  <div class="toolbar-inner">
                    <div class="title margin-left">
                    <h3
                    class="text-align-left"
                    style="
                    margin:0;
                    font-weight:700;
                    letter-spacing:.2px;
                    background: linear-gradient(135deg, #FFF2B0 0%, #F7D774 25%, #D4AF37 55%, #B8860B 100%);
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                    "
                    >
                    Order Details
                    </h3>
                    </div>
                    <div class="right">
                    <a
                    href="#"
                    class="link sheet-close"
                    aria-label="Close"
                    style="
                    padding:0 8px;
                    color:#fff;
                    opacity:.9;
                    "
                    >
                    <i class="icon f7-icons" style="font-size:22px; line-height:22px; color:#fff;">xmark</i>
                    </a>
                    </div>
                  </div>
                  </div>

                  <div class="sheet-modal-inner" style="background: transparent;">
                  <div class="sheet-modal-text" style="color:#fff;">
                    <div class="list" style="margin:0;">
                    <ul style="background: transparent;">
                    <li style="border-bottom:1px solid rgba(255,255,255,0.06);">
                    <div class="item-content">
                      <div class="item-inner">
                      <div class="item-title" style="color: rgba(255,255,255,0.7);">Investment Reference ID</div>
                      <div class="item-after f-12" style="color:#fff; font-weight:600;">${itemData.investID}</div>
                      </div>
                    </div>
                    </li>

                    <li style="border-bottom:1px solid rgba(255,255,255,0.06);">
                    <div class="item-content">
                      <div class="item-inner">
                      <div class="item-title" style="color: rgba(255,255,255,0.7);">Amount</div>
                      <div class="item-after" style="color:#fff; font-weight:700;">${itemData.amount}</div>
                      </div>
                    </div>
                    </li>

                    <li style="border-bottom:1px solid rgba(255,255,255,0.06);">
                    <div class="item-content">
                      <div class="item-inner">
                      <div class="item-title" style="color: rgba(255,255,255,0.7);">Gold Quantity</div>
                      <div class="item-after" style="color:#fff; font-weight:600;">${itemData.goldQTY} gm</div>
                      </div>
                    </div>
                    </li>

                    <li style="border-bottom:1px solid rgba(255,255,255,0.06);">
                    <div class="item-content">
                      <div class="item-inner">
                      <div class="item-title" style="color: rgba(255,255,255,0.7);">Status</div>
                      <div class="item-after fw-600 ${statusColor}" style="color:#fff;">
                      ${status}
                      </div>
                      </div>
                    </div>
                    </li>

                    <li>
                    <div class="item-content">
                      <div class="item-inner">
                      <div class="item-title" style="color: rgba(255,255,255,0.7);">Activation Date</div>
                      <div class="item-after" style="color:#fff; font-weight:600;">${itemData.date}</div>
                      </div>
                    </div>
                    </li>
                    </ul>
                    </div>

                    <div class="block text-align-center" style="display:flex; flex-direction:column; gap:12px; margin-top:14px;">
                    <button
                    class="button button-large sheet-close"
                    style="
                    width:100%;
                    border-radius:14px;
                    border: 1px solid transparent;
                    background:
                      linear-gradient(#070B16, #070B16) padding-box,
                      linear-gradient(135deg, #FFF2B0 0%, #F7D774 25%, #D4AF37 60%, #B8860B 100%) border-box;
                    color:#F7D774;
                    font-weight:700;
                    letter-spacing:.2px;
                    box-shadow: 0 0 18px rgba(212,175,55,0.10);
                    "
                    >
                    Okay
                    </button>

                    ${
                    showInvoiceBtn
                      ? `
                    <button
                    class="button button-large download-invoice"
                    style="
                    width:100%;
                    border-radius:14px;
                    border: 1px solid rgba(255,255,255,0.06);
                    background: linear-gradient(135deg, #FFF2B0 0%, #F7D774 25%, #D4AF37 60%, #B8860B 100%);
                    color:#1b1406;
                    font-weight:800;
                    letter-spacing:.2px;
                    box-shadow:
                      0 14px 34px rgba(0,0,0,0.45),
                      0 0 28px rgba(212,175,55,0.18);
                    "
                    >
                    Download Invoice
                    </button>
                    `
                      : ''
                    }
                    </div>
                  </div>
                  </div>
                  </div>
                  `,
                  swipeToClose: true,
                  backdrop: true
                });
              detailsSheet.open();
            } else {
              app.preloader.hide();
              app.toast.show({
                text: 'Investment details not found!',
                closeTimeout: 3000,
              });
            }
            // download invoice
            $$(document).off('click', '.download-invoice');
            $$(document).on('click', '.download-invoice', function() {
              //create a good html template for invoice and download it as pdf using jsPDF
              var JsPDFCtor = (window.jspdf && window.jspdf.jsPDF) || window.jsPDF;
              if (!JsPDFCtor) {
                app.toast.show({ text: 'jsPDF not loaded. Please include jsPDF to download invoice.', closeTimeout: 3000 });
                return;
              }

              function escapeHtml(str) {
                return String(str == null ? '' : str).replace(/[&<>"']/g, function (m) {
                  return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m];
                });
              }

              function toNumber(val) {
                var n = Number(String(val == null ? '' : val).replace(/[^0-9.]/g, ''));
                return Number.isFinite(n) ? n : 0;
              }

              app.dialog.progress('Generating Invoice...');

              app.methods.getUserData(function (user) {
                try {
                  var now = new Date();
                  var invoiceNo = String(itemData.investID || 'INV');
                  var invoiceDate = (itemData.date && String(itemData.date).split(' ')[0]) || now.toLocaleDateString('en-IN');

                  var baseAmount = toNumber(itemData.amount);
                  var gstRate = 0.03;
                  var gstAmount = Number((baseAmount * gstRate).toFixed(2));
                  var totalPayable = Number((baseAmount + gstAmount).toFixed(2));

                  var goldQty = Number(String(itemData.goldQTY || '').replace(/[^0-9.]/g, '')) || 0;
                  var goldRate = toNumber(itemData.goldRates || itemData.goldRate || (typeof data !== 'undefined' ? data.goldRate : 0));
                  var estReturn = toNumber(itemData.estimatedReturn);
                  var dailyReturn = toNumber(itemData.dailyReturn);

                  var customerName = escapeHtml(user && user.name ? user.name : 'Customer');
                  var customerEmail = escapeHtml(user && user.email ? user.email : '');
                  var customerPhone = escapeHtml(user && user.phone ? ('+91' + user.phone) : '');

                    var logoUrl = 'https://vyoorajewels.com/assets/images/logo.png';

                    var html = `
                    <div id="invoice-vyoora" style="width:794px; background:#ffffff; color:#0f172a; padding:28px; box-sizing:border-box; font-family: Helvetica, Arial, sans-serif;">
                      <!-- Header -->
                      <div style="display:flex; justify-content:space-between; align-items:flex-start; gap:16px; padding-bottom:14px; border-bottom:2px solid #e5e7eb;">
                      <div style="display:flex; align-items:center; gap:12px; min-width:0;">
                        <div style="width:84px; height:84px; border-radius:12px; border:1px solid #e5e7eb; display:flex; align-items:center; justify-content:center; overflow:hidden; background:#fff; flex:0 0 auto;">
                        <img src="${escapeHtml(logoUrl)}" alt="Vyoora Jewels" style="max-width:100%; max-height:100%; display:block;" />
                        </div>
                        <div style="min-width:0;">
                        <div style="font-size:20px; font-weight:800; letter-spacing:.2px; line-height:1.2;">Vyoora Jewels</div>
                        <div style="font-size:12px; color:#475569; margin-top:3px; line-height:1.25;">Invoice • Digital Gold Investment</div>
                        <div style="font-size:12px; color:#475569; margin-top:3px; line-height:1.25;">https://vyoorajewels.com</div>
                        <div style="font-size:12px; color:#475569; margin-top:3px; line-height:1.25;">support@vyoorajewels.com</div>
                        </div>
                      </div>

                      <div style="text-align:right; min-width:230px; flex:0 0 auto;">
                        <div style="display:inline-block; padding:7px 12px; border-radius:999px; background:#0f172a; color:#fff; font-size:12px; font-weight:800; letter-spacing:.4px;">
                        TAX INVOICE
                        </div>
                        <div style="margin-top:10px; font-size:12px; color:#334155; line-height:1.55;">
                        <div><b>Invoice No:</b> ${escapeHtml(invoiceNo)}</div>
                        <div><b>Invoice Date:</b> ${escapeHtml(invoiceDate)}</div>
                        <div><b>Generated:</b> ${escapeHtml(now.toLocaleString('en-IN'))}</div>
                        </div>
                      </div>
                      </div>

                      <!-- Party details -->
                      <div style="display:flex; justify-content:space-between; gap:14px; margin-top:14px;">
                      <div style="flex:1; border:1px solid #e5e7eb; border-radius:12px; padding:12px; min-width:0;">
                        <div style="font-size:11px; font-weight:800; color:#0f172a; letter-spacing:.08em; text-transform:uppercase; margin-bottom:8px;">Billed To</div>
                        <div style="font-size:13px; font-weight:800; color:#0f172a; line-height:1.2;">${customerName}</div>
                        ${customerPhone ? `<div style="font-size:12px; color:#475569; margin-top:5px; line-height:1.25;">${customerPhone}</div>` : ''}
                        ${customerEmail ? `<div style="font-size:12px; color:#475569; margin-top:3px; line-height:1.25; word-break:break-word;">${customerEmail}</div>` : ''}
                      </div>

                      <div style="flex:1; border:1px solid #e5e7eb; border-radius:12px; padding:12px; min-width:0;">
                        <div style="font-size:11px; font-weight:800; color:#0f172a; letter-spacing:.08em; text-transform:uppercase; margin-bottom:8px;">Invoice Details</div>
                        <div style="font-size:12px; color:#475569; line-height:1.55;">
                        <div><b>Product:</b> Digital Gold Investment</div>
                        <div style="margin-top:4px;"><b>Reference ID:</b> #${escapeHtml(itemData.investID)}</div>
                        <div style="margin-top:4px;"><b>Gold Quantity:</b> ${escapeHtml(goldQty ? goldQty.toFixed(3) : (itemData.goldQTY || 'N/A'))} gm</div>
                        </div>
                      </div>
                      </div>

                      <!-- Items -->
                      <div style="margin-top:14px; border:1px solid #e5e7eb; border-radius:12px; overflow:hidden;">
                      <table style="width:100%; border-collapse:collapse;">
                        <thead>
                        <tr style="background:#f8fafc;">
                          <th style="text-align:left; padding:10px 12px; font-size:12px; color:#334155; border-bottom:1px solid #e5e7eb;">Description</th>
                          <th style="text-align:right; padding:10px 12px; font-size:12px; color:#334155; border-bottom:1px solid #e5e7eb;">Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td style="padding:10px 12px; font-size:12px; color:#0f172a; border-bottom:1px solid #eef2f7;">
                          Digital Gold Investment (Taxable Value)
                          <div style="font-size:11px; color:#64748b; margin-top:4px; line-height:1.35;">
                            Qty: ${escapeHtml(goldQty ? goldQty.toFixed(3) : (itemData.goldQTY || 'N/A'))} gm • Ref: #${escapeHtml(itemData.investID)}
                          </div>
                          </td>
                          <td style="padding:10px 12px; font-size:12px; text-align:right; color:#0f172a; border-bottom:1px solid #eef2f7;">
                          ${escapeHtml(INR2.format(baseAmount))}
                          </td>
                        </tr>

                        <tr>
                          <td style="padding:10px 12px; font-size:12px; color:#0f172a; border-bottom:1px solid #eef2f7;">
                          GST @ 3%
                          </td>
                          <td style="padding:10px 12px; font-size:12px; text-align:right; color:#0f172a; border-bottom:1px solid #eef2f7;">
                          ${escapeHtml(INR2.format(gstAmount))}
                          </td>
                        </tr>

                        <tr>
                          <td style="padding:12px; font-size:13px; font-weight:900; color:#0f172a;">
                          Total Payable
                          </td>
                          <td style="padding:12px; font-size:13px; font-weight:900; text-align:right; color:#0f172a;">
                          ${escapeHtml(INR2.format(totalPayable))}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      </div>

                      <!-- Notes (full-width) -->
                      <div style="margin-top:14px; border:1px solid #e5e7eb; border-radius:12px; padding:12px;">
                      <div style="font-size:11px; font-weight:800; color:#0f172a; letter-spacing:.08em; text-transform:uppercase; margin-bottom:8px;">Notes</div>
                      <div style="font-size:11px; color:#64748b; line-height:1.55;">
                        This is a system-generated invoice for your records.<br/>
                        For support, contact: support@vyoorajewels.com
                      </div>
                      </div>

                      <div style="margin-top:14px; padding-top:10px; border-top:1px solid #eef2f7; font-size:10.5px; color:#64748b; text-align:center;">
                      © ${now.getFullYear()} Vyoora Jewels. All rights reserved.
                      </div>
                    </div>
                    `;

                  // IMPORTANT:
                  // Empty PDFs usually happen when the render target is fully transparent (opacity:0),
                  // or when fonts/images are not loaded yet at capture time.
                  // Keep the invoice node "visible" (opacity:1) but behind the UI, then wait for assets.
                  var container = document.createElement('div');
                  container.id = 'invoice-vyoora-render-root';
                  container.style.position = 'fixed';
                  container.style.left = '0';
                  container.style.top = '0';
                  container.style.width = '794px';
                  container.style.background = '#ffffff';
                  container.style.opacity = '1';
                  container.style.pointerEvents = 'none';
                  container.style.zIndex = '-1';
                  container.innerHTML = html;
                  document.body.appendChild(container);

                  // Render the actual invoice element (inner #invoice-vyoora) if present
                  var invoiceEl = container.querySelector('#invoice-vyoora') || container;

                  function waitForImages(el) {
                    var imgs = Array.prototype.slice.call(el.querySelectorAll('img'));
                    return Promise.all(
                      imgs.map(function (img) {
                        return new Promise(function (resolve) {
                          if (img.complete && img.naturalWidth > 0) return resolve();
                          img.onload = function () { resolve(); };
                          img.onerror = function () { resolve(); }; // don't block on broken CORS images
                        });
                      })
                    );
                  }

                  function waitForFonts() {
                    if (document.fonts && document.fonts.ready) {
                      return document.fonts.ready.catch(function () {});
                    }
                    return Promise.resolve();
                  }

                  var doc = new JsPDFCtor({ orientation: 'landscape', unit: 'pt', format: 'a2' });

                  // Fallback if html plugin/html2canvas isn't present (prevents blank PDFs)
                  if (typeof doc.html !== 'function' || typeof window.html2canvas === 'undefined') {
                    doc.setFontSize(14);
                    doc.text('Vyoora Jewels - Digital Gold Investment Invoice', 20, 40);
                    doc.setFontSize(11);
                    doc.text('Invoice No: ' + invoiceNo, 20, 60);
                    doc.text('Date: ' + invoiceDate, 20, 76);
                    doc.text('Customer: ' + (user && user.name ? user.name : 'Customer'), 20, 92);
                    doc.text('Amount (Base): ' + INR2.format(baseAmount), 20, 120);
                    doc.text('GST @ 3%: ' + INR2.format(gstAmount), 20, 136);
                    doc.text('Total Payable: ' + INR2.format(totalPayable), 20, 152);
                    doc.text('Gold Qty: ' + (goldQty ? goldQty.toFixed(3) : (itemData.goldQTY || 'N/A')) + ' gm', 20, 168);
                    doc.text('Ref ID: #' + (itemData.investID || ''), 20, 184);

                    try {
                      var fileName = 'Invoice_' + invoiceNo + '.pdf';
                      doc.save(fileName);
                    } finally {
                      app.dialog.close();
                      document.body.removeChild(container);
                    }
                    return;
                  }

                  Promise.all([waitForFonts(), waitForImages(invoiceEl)]).then(function () {
                    // Wait a frame so layout is computed before rendering into canvas/PDF.
                    requestAnimationFrame(function () {
                      doc.html(invoiceEl, {
                        x: 20,
                        y: 20,
                        width: 1360, // max width on A4 at 72dpi with 20pt margin
                        windowWidth: 794,
                        autoPaging: 'text',
                        html2canvas: { scale: 2, useCORS: true, allowTaint: true, backgroundColor: '#ffffff' },
                        callback: function (pdf) {
                          try {
                            var fileName = 'Invoice_' + invoiceNo + '.pdf';
                            pdf.save(fileName);
                          } finally {
                            app.dialog.close();
                            document.body.removeChild(container);
                          }
                        }
                      });
                    });
                  });
                } catch (err) {
                  app.dialog.close();
                  app.toast.show({ text: 'Failed to generate invoice. Please try again.', closeTimeout: 3000 });
                  // eslint-disable-next-line no-console
                  console.log(err);
                }
              });
            });
          });
        });
      }
    }
  },
  {
    path: '/earning/',
    component: EarningPage,
    name: 'earning',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(data) {
          if(data.isLoggedin == 'true') {
            app.dialog.close();
            $$('.referral-code').html(data.referralCode);
            $$('.invite-link-btn').attr('data-referral', data.referralCode);
          } else {
            app.dialog.close();
            app.views.main.router.navigate({name: 'Home'});
          }
        });
        //copy-icon copy referral code
        $$('.copy-icon').on('click', function(e) {
          e.preventDefault();
          var text = $$('.referral-code').text();
          if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(text).then(function() {
              app.toast.show({text: 'Copied!', closeTimeout: 1500});
            });
          } else {
            // fallback for older browsers
            var tempInput = document.createElement('input');
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
            app.toast.show({text: 'Copied!', closeTimeout: 1500});
          }
        });
        $$('.invite-link-btn').on('click', function() {
          var shareLink = 'https://app.vyoorajewels.com/#!/register/referral/' + $$(this).attr('data-referral');
          if (navigator.share) {
            navigator.share({
              title: 'Join YouPayWallet',
              text: 'Use my referral code to join YouPayWallet!',
              url: '' + shareLink
            }).catch(() => {});
          } else {
            console.log('Web Share API not supported in this browser.');
            //copy the link to clipboard
            if (navigator && navigator.clipboard) {
              navigator.clipboard.writeText(shareLink).then(function() {
                app.toast.show({text: 'Invitation link copied to clipboard!', closeTimeout: 1500});
              });
            }
          }
        });
        //get eraning from server
        app.methods.request(
          baseURL+'/app/php/earning.php',
          {getEarnings: true, token: localStorage.getItem('authToken')},
          'json',
          function() { app.dialog.progress('Loading Earnings...'); },
          function(data) {
            app.dialog.close();
            if(data.status == 'success') {
              $$('.network__wallet--amount').html(INR2.format(data.data.myCommissionAmount));
              $$('.total-members').html(data.data.teamMembers);
              $$('.total-direct-referrals').html(data.data.directMembers);
              $$('.team-commission').html(INR2.format(data.data.totalCommission));
              $$('.direct-commission').html(INR2.format(data.data.totalDirectCommission));
              // Set progress bar
              var current = parseFloat(data.data.totalCommission);
              var cap = parseFloat(data.data.commissionCap);
              $$('.commissionCappingtext').html(INR2.format(current) + ' / ' + INR2.format(cap));
              var percentage = Math.min((current / cap) * 100, 100); // Ensure percentage does not exceed 100%
              // Set progress dynamically
              app.progressbar.set('#earnings-progress', percentage);
              if(data.data.teamMembers > 0) {
                $$('.item__link--earning-team').attr('href', '/my-team/');
              }
            } else {
              app.toast.show({
                text: data.msg,
                closeTimeout: 3000,
              });
            }
          },
          function() {
            app.dialog.close();
            app.toast.show({
              text: 'No internet connection!',
              closeTimeout: 3000,
            });
          }
        );
      }
    }
  },
  {
    path: '/my-team/',
    component: MyTeamPage,
    name: 'my-team',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(data) {
          if(data.isLoggedin == 'true') {
            app.dialog.close();
            $$('.referral-code').html(data.referralCode);
          } else {
            app.dialog.close();
            app.views.main.router.navigate({name: 'Home'});
          }
        });
        //get eraning from server
        app.methods.request(
          baseURL+'/app/php/earning.php',
          {getEarnings: true, token: localStorage.getItem('authToken')},
          'json',
          function() { app.dialog.progress('Loading Earnings...'); },
          function(data) {
            app.dialog.close();
            if(data.status == 'success') {
              $$('.total-members').html(data.data.teamMembers);
              $$('.total-direct-referrals').html(data.data.directMembers);
            } else {
              app.toast.show({
                text: data.msg,
                closeTimeout: 3000,
              });
            }
          },
          function() {
            app.dialog.close();
            app.toast.show({
              text: 'No internet connection!',
              closeTimeout: 3000,
            });
          }
        );
        //my team data
        app.methods.request(
          baseURL+'/app/php/earning.php',
          {myTeam: true, token: localStorage.getItem('authToken')},
          'json',
          function() { app.dialog.progress('Loading Data...'); },
          function(data) {
            app.dialog.close();
            if(data.status == 'success') {
              if (Array.isArray(data.data.binaryTree) && data.data.binaryTree.length > 0) {
                $$('.all-teams--list ul').empty();
                data.data.binaryTree.forEach(function(member) {
                  var status = member.network.status == '1' ? 'Active' : 'Inactive';
                  var statusColor = member.network.status == '1' ? 'text-color-green' : 'text-color-red-deep';
                  $$('.all-teams--list ul').append(
                    '<li>' +
                      '<div class="item-content">' +
                        '<div class="item-media">' +
                          '<img src="https://ui-avatars.com/api/?background=fbd2e4&color=ed1e79&length=2&rounded=true&bold=true&name=' + encodeURIComponent(member.user.name) + '" width="40"/>' +
                        '</div>' +
                        '<div class="item-inner">' +
                          '<div class="item-title-row">' +
                            '<div class="item-title fw-600">' + member.user.name + '</div>' +
                            '<div class="item-after f-12 fw-600 ' + statusColor + '">' + status + '</div>' +
                          '</div>' +
                          '<div class="item-subtitle f-12">' + member.user.email + '</div>'+
                          '<div class="item-text text-color-blue f-14 fw-600">Total Investment:' + INR2.format(member.totalInvestment) + '</div>' +
                        '</div>' +
                      '</div>' +
                    '</li>'
                  );
                });
              } else {
                $$('.all-teams--list ul').empty();
                $$('.all-teams--list ul').append(
                  '<li>' +
                    '<div class="item-content">' +
                      '<div class="item-inner text-align-center">' +
                        '<img src="assets/icons/no-data.png" height="70" style="margin-top: 25px;"/>' +
                        '<h3 class="text-color-blue f-16">No direct members found!</h3>' +
                      '</div>' +
                    '</div>' +
                  '</li>'
                );
              }
            } else {
              app.toast.show({
                text: data.msg,
                closeTimeout: 3000,
              });
            }
          },
          function() {
            app.dialog.close();
            app.toast.show({
              text: 'No internet connection!',
              closeTimeout: 3000,
            });
          }
        );
        //check if popup-genealogy-tree opened or not
        // Recursively convert the structure to Tree.js format
        function convertToJsTree(node) {
          const item = {
            text: node.name+' ('+node.position+')'
          };

          if (node.children && node.children.length > 0) {
            item.children = node.children.map(convertToJsTree);
          }

          return item;
        }

        $$(document).on('popup:opened', '.popup-genealogy-tree', function () {
          // You can add any logic here that should run when the genealogy tree popup is opened
            //get genealogy tree data
            app.methods.request(
            baseURL + '/app/php/earning.php',
            { getGenealogyTree: true, token: localStorage.getItem('authToken') },
            'json',
            function() { app.dialog.progress('Loading Genealogy Tree...'); },
            function(data) {
              app.dialog.close();
              if (data.status === 'success' && data.data.genealogyTree) {
                const convertedChildren = data.data.genealogyTree.map(convertToJsTree);
                // Clear previous tree and style container
                $$('.genealogy-tree-container').empty();
                $$('.genealogy-tree-container').removeClass('text-align-center');
                $$('.genealogy-tree-container').addClass('text-align-left');
                // Initialize jsTree with custom icons/colors
                $('#tree-container').jstree({
                  core: {
                  themes: {
                    name: 'default',
                    responsive: false
                  },
                  data: convertedChildren
                  },
                  types: {
                  default: {
                    icon: 'fa fa-user text-color-red'
                  }
                  },
                  plugins: ['types']
                });
              }
            },
            function() {
              app.dialog.close();
              $$('.genealogy-tree-container').empty();
              $$('.genealogy-tree-container').append('<img src="assets/icons/no-data.png" height="70" style="margin-top: 125px;"/>\
              <p class="fs-16 fw-600 text-color-blue">Failed to load genealogy data. Please try again later.</p>\
              )');
            }
            );
        });
      }
    }
  },
  {
    path: '/returns/',
    component: ReturnPage,
    name: 'returns',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        //check if logged in or not
        app.methods.getUserData(
          function(data) {
            if(data.isLoggedin == 'true') {
              app.dialog.close();
              //get payment history
              $.post(baseURL+"app/php/invest.php", {returnHistory:true,token:localStorage.getItem('authToken')}, function() {
                app.dialog.close();
              })
              .done(function(data) {
                app.dialog.close();
                if(data.status == 'success') {
                  $$('.txn-history .list ul').empty();
                  if(typeof data.returnHistory == 'undefined' || data.returnHistory.length == 0) {
                    $$('.txn-history').empty();
                    $$('.txn-history').append('<div class="text-align-center">\
                      <img src="assets/icons/no-data.png" height="70" style="margin-top: 125px;"/>\
                      <h3 class="text-color">No return history found!</h3>\
                    </div>');
                  } else {
                    $.each(data.returnHistory, function(i, item) {
                      if(item.status == '0') {
                        var status = 'Pending';
                        var statusColor = 'text-color-orange';
                        var img = 'assets/icons/pending.png';
                      } else if(item.status == '1') {
                        var status = 'Success';
                        var statusColor = 'text-color-green';
                        var img = 'assets/icons/checked.png';
                      } else {
                        var status = 'Failed';
                        var statusColor = 'text-color-red-deep';
                        var img = 'assets/icons/error.png';
                      }
                      if(item.type == '1') {
                        var title = 'Daily Return Received';
                      } else {
                        var title = 'Refund Received';
                      }
                      $$('.txn-history .list ul').append('<li>\
                      <div class="item-content">\
                        <div class="item-media">\
                          <img src="'+img+'" height="40">\
                        </div>\
                        <div class="item-inner">\
                          <div class="item-title-row">\
                            <div class="item-title fw-600">'+title+'</div>\
                            <div class="item-after f-16 fw-600 text-color-blue">'+INR2.format(item.amount)+'</div>\
                          </div>\
                          <div class="item-text f-12">'+item.investID+'</div>\
                          <div class="item-text f-12">ROI: '+item.roi+'%</div>\
                          <div class="item-subtitle f-12 fw-600 '+statusColor+'">'+status+'</div>\
                          <div class="item-text f-12">'+item.date+'</div>\
                        </div>\
                      </div>\
                    </li>');
                    });
                  }
                } else {
                  $$('.txn-history').empty();
                  $$('.txn-history').append('<div class="text-align-center">\
                    <img src="assets/icons/no-data.png" height="70" style="margin-top: 125px;"/>\
                    <h3 class="text-color-blue f-16">No return history found!</h3>\
                  </div>');
                }
              })
              .fail(function() {
                app.dialog.close();
                app.toast.show({
                  text: 'Something went wrong, please try again!',
                  closeTimeout: 3000,
                });
              });
            } else {
              app.dialog.close();
              app.views.main.router.navigate({name: 'Home'});
            }
        });
      }
    }
  },
  {
    path: '/invest-withdraw/',
    component: InvestWithdrawPage,
    name: 'invest-withdraw',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        //get subscription details
        app.methods.getUserDataInvest(function(data) {
          app.dialog.close();
          if(data.status == 'success') {
            data.withdrawalBal = parseFloat(data.withdrawalBal);
            $$('.wallet--amount').html(INR2.format(data.withdrawalBal));
            $$('input[name="amount"]').attr('max', data.withdrawalBal);
            $$('input[name="wallet"]').val(data.withdrawalBal);
            //each loop
            $$('#investmentSelect').empty();
            $.each(data.data, function(i, item) {
              //filter item where item.status is 1
              if(item.status != '1') {
                return;
              }
              $$('#investmentSelect').append('<option value="'+item.investID+'">'+item.investID+' - '+INR.format(item.wallet)+' - '+item.roi+'x Returns - '+item.days+' Days</option>');
              //select2
              $('#investmentSelect').select2({minimumResultsForSearch: -1});
              //get which investment is selected
              var investID = $$('#investmentSelect').val();
              //match investment id with selected investment
              if(item.investID == investID) {
                $$('.wallet--amount').html(INR2.format(item.withdrawalLimit));
                $$('input[name="amount"]').attr('max', item.maxWithdrawal);
                $$('input[name="wallet"]').val(item.withdrawalLimit);
                //if item.withdrawn is null show a dialog box warning
                if(item.withdrawn == 0) {
                  $$('.card__warning').removeClass('hidden');
                  $$('.holding-date').html(item.halfwayDate);
                  $$('.gold-amount').html(INR2.format(item.wallet));
                } else {
                  $$('.card__warning').removeClass('hidden');
                  $$('.card__warning-txt').html('As you have already withdrawn your investment, you can not get gold benefits from this investment anymore.');
                }
                //calculate item.withdrawalLimit + 5%, if it's 1000 then it should be 1050
                var withdrawalwithTax = +item.withdrawalLimit + +(item.withdrawalLimit * 0.05);
                if(withdrawalwithTax >= 1050) {
                    $$('.block-moneyTransfer').removeClass('hidden');
                    $$('.withdrawMoney').removeClass('disabled');
                    var withdrwalAmount = withdrawalwithTax - (withdrawalwithTax * 0.05);
                    withdrwalAmount = parseFloat(withdrwalAmount).toFixed(2);
                    $$('.wd-balST').removeClass('text-color-red-deep');
                    $$('.wd-balST').addClass('text-color-blue');
                    $$('.wd-balST').html('You can withdraw up to '+INR2.format(item.maxWithdrawal)+' from your investment.');
                  } else {
                    $$('.withdrawMoney').addClass('disabled');
                  }
              }
              $('#investmentSelect').on('change', function() {
                var investID = $$('#investmentSelect').val();
                //match investment id with selected investment
                if(item.investID == investID) {
                  $$('.wallet--amount').html(INR2.format(item.withdrawalLimit));
                  $$('input[name="amount"]').attr('max', item.maxWithdrawal);
                  $$('input[name="wallet"]').val(item.withdrawalLimit);
                  if(item.withdrawn == 0) {
                    $$('.card__warning').removeClass('hidden');
                    $$('.holding-date').html(item.halfwayDate);
                    $$('.gold-amount').html(INR2.format(item.wallet));
                  } else {
                    $$('.card__warning').removeClass('hidden');
                    $$('.card__warning-txt').html('As you have already withdrawn your investment, you can not get gold benefits from this investment anymore.');
                  }
                  //calculate item.withdrawalLimit + 5%, if it's 1000 then it should be 1050
                  var withdrawalwithTax = +item.withdrawalLimit + +(item.withdrawalLimit * 0.05);
                  if(withdrawalwithTax >= 1050) {
                    $$('.block-moneyTransfer').removeClass('hidden');
                    $$('.withdrawMoney').removeClass('disabled');
                    var withdrwalAmount = withdrawalwithTax - (withdrawalwithTax * 0.05);
                    withdrwalAmount = parseFloat(withdrwalAmount).toFixed(2);
                    $$('.wd-balST').removeClass('text-color-red-deep');
                    $$('.wd-balST').addClass('text-color-blue');
                    $$('.wd-balST').html('You can withdraw up to '+INR2.format(item.maxWithdrawal)+' from your investment.');
                  } else {
                    $$('.withdrawMoney').addClass('disabled');
                  }
                }
              });
              if(item.isWeekend == true) {
                $$('.w-timetxt').html('Withdrawals are not allowed on weekends, you can withdraw on next business day.');
                $$('.withdrawMoney').addClass('disabled');
              } else {
                $$('.w-timetxt').html('');
              }
            });
          } else {
            //redirect to home page
            var view = app.views.current;
            view.router.navigate({name: 'Home'});
          }
        });
        app.methods.getUserDataLocker(function(data) {
          app.dialog.close();
          if(data.status == 'success') {
            //check if bankAccounts is array or not
            if(Array.isArray(data.bankAccounts) && data.bankAccounts.length > 0) {
              $$('#investWithFrm').removeClass('hidden');
              $$('.beneficiaryContent').addClass('hidden');
              $$('.selectBeneficiaryList').removeClass('hidden');
              var allBankAccounts = data.bankAccounts;
              //create bank account select list in selectBeneficiary
              $$('.selectBeneficiary').empty();
              allBankAccounts.forEach(function(account, idx) {
                $$('#selectBeneficiary').append(
                  '<option value="'+account.bankAC+'"'
                  + ' data-beneficiary="'+account.beneficiaryName+'"'
                  + ' data-bankname="'+account.bankName+'"'
                  + ' data-ifsc="'+account.bankIFSC+'"'
                  + ' data-receiverphone="'+account.receiverPhone+'"'
                  + ' data-receiveremail="'+account.receiverMail+'"'
                  + (idx === 0 ? ' selected' : '')
                  + '>'
                  + account.beneficiaryName+' - '+account.bankAC+' ('+account.bankName+')'
                  + '</option>'
                );
              });
              //init select2
              $('#selectBeneficiary').select2();
              $$('.block-beneficiaryDetails').removeClass('hidden');
              //first show selected beneficiary details
              var selectedBeneficiary = $('#selectBeneficiary option:selected');
              $$('.block-beneficiaryDetails').empty();
              $$('.block-beneficiaryDetails').append('<div class="card card-main">\
                <div class="card-content">\
                  <p class="text-color-blue f-14"><b>Beneficiary Name:</b> '+selectedBeneficiary.data('beneficiary')+'</p>\
                  <p class="text-color-blue f-14"><b>Bank Name:</b> '+selectedBeneficiary.data('bankname')+'</p>\
                  <p class="text-color-blue f-14"><b>Account Number:</b> '+selectedBeneficiary.val()+'</p>\
                  <p class="text-color-blue f-14"><b>IFSC Code:</b> '+selectedBeneficiary.data('ifsc')+'</p>\
                  <p class="text-color-blue f-14"><b>Beneficiary Phone:</b> '+selectedBeneficiary.data('receiverphone')+'</p>\
                  <p class="text-color-blue f-14"><b>Beneficiary Email:</b> '+selectedBeneficiary.data('receiveremail')+'</p>\
                </div>\
              </div>');
              //beneficiary content add value to each field
              $$('.beneficiaryContent #beneficiary').val(selectedBeneficiary.data('beneficiary'));
              $$('.beneficiaryContent #bankname').val(selectedBeneficiary.data('bankname'));
              $$('.beneficiaryContent #account').val(selectedBeneficiary.val());
              $$('.beneficiaryContent #caccount').val(selectedBeneficiary.val());
              $$('.beneficiaryContent #ifsc').val(selectedBeneficiary.data('ifsc'));
              $$('.beneficiaryContent #receiverPhone').val(selectedBeneficiary.data('receiverphone'));
              $$('.beneficiaryContent #receiverEmail').val(selectedBeneficiary.data('receiveremail'));
              //on change of select box of beneficiary
              $('#selectBeneficiary').on('change', function() {
                var selectedBeneficiary = $('#selectBeneficiary option:selected');
                $$('.block-beneficiaryDetails').empty();
                $$('.block-beneficiaryDetails').append('<div class="card card-main">\
                  <div class="card-content">\
                    <p class="text-color-blue f-14"><b>Beneficiary Name:</b> '+selectedBeneficiary.data('beneficiary')+'</p>\
                    <p class="text-color-blue f-14"><b>Bank Name:</b> '+selectedBeneficiary.data('bankname')+'</p>\
                    <p class="text-color-blue f-14"><b>Account Number:</b> '+selectedBeneficiary.val()+'</p>\
                    <p class="text-color-blue f-14"><b>IFSC Code:</b> '+selectedBeneficiary.data('ifsc')+'</p>\
                    <p class="text-color-blue f-14"><b>Beneficiary Phone:</b> '+selectedBeneficiary.data('receiverphone')+'</p>\
                    <p class="text-color-blue f-14"><b>Beneficiary Email:</b> '+selectedBeneficiary.data('receiveremail')+'</p>\
                  </div>\
                </div>');
                //beneficiary content add value to each field
                $$('.beneficiaryContent #beneficiary').val(selectedBeneficiary.data('beneficiary'));
                $$('.beneficiaryContent #bankname').val(selectedBeneficiary.data('bankname'));
                $$('.beneficiaryContent #account').val(selectedBeneficiary.val());
                $$('.beneficiaryContent #caccount').val(selectedBeneficiary.val());
                $$('.beneficiaryContent #ifsc').val(selectedBeneficiary.data('ifsc'));
                $$('.beneficiaryContent #receiverPhone').val(selectedBeneficiary.data('receiverphone'));
                $$('.beneficiaryContent #receiverEmail').val(selectedBeneficiary.data('receiveremail'));
              });
            } else {
              $$('#investWithFrm').removeClass('hidden');
              $$('.beneficiaryContent').addClass('hidden');
              $$('.selectBeneficiaryList').addClass('hidden');
            }
            //create sheet-add-beneficiary
            // Create Add Beneficiary Sheet
            var addBeneficiarySheet = app.sheet.create({
              content: `
              <div class="sheet-modal sheet-add-beneficiary" style="height:auto;">
              <div class="toolbar">
                <div class="toolbar-inner">
                  <div class="title text-color-blue margin-left"><h3 class="text-color-blue text-align-left">Add Beneficiary</h3></div>
                  <div class="right">
                    <a href="#" class="link sheet-close">
                      <img src="assets/icons/x-button.png" width="24" height="24" alt="Close" class="icon icon-close">
                    </a>
                  </div>
                </div></div>
                <div class="sheet-modal-inner">
                <div class="sheet-modal-text">
                  <form id="addBeneficiaryForm">
                  <div class="list">
                    <ul>
                    <li class="item-content item-input ">
                      <div class="item-inner">
                          <div class="item-title item-floating-label" style="background-color: #FFF !important">Beneficiary Name</div>
                          <div class="item-input-wrap">
                              <div class="flex d-row">
                                  <input type="text" name="bnbeneficiary" id="bnbeneficiary" required validate>
                              </div>
                          </div>
                      </div>
                    </li>
                    <li class="item-content item-input ">
                        <div class="item-inner">
                            <div class="item-title item-floating-label" style="background-color: #FFF !important">Beneficiary Phone (Optional)</div>
                            <div class="item-input-wrap">
                                <div class="flex d-row">
                                    <input type="tel" maxlength="10" minlength="10" name="bnreceiverPhone" id="bnreceiverPhone">
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="item-content item-input ">
                        <div class="item-inner">
                            <div class="item-title item-floating-label" style="background-color: #FFF !important">Beneficiary Email (Optional)</div>
                            <div class="item-input-wrap">
                                <div class="flex d-row">
                                    <input type="email" name="bnreceiverEmail" id="bnreceiverEmail" validate>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="item-content item-input ">
                        <div class="item-inner">
                            <div class="item-title item-floating-label" style="background-color: #FFF !important">Account Number</div>
                            <div class="item-input-wrap">
                                <div class="flex d-row">
                                    <input type="password" name="bnaccount" id="bnaccount" required validate>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="item-content item-input ">
                        <div class="item-inner">
                            <div class="item-title item-floating-label" style="background-color: #FFF !important">Confirm Account Number</div>
                            <div class="item-input-wrap">
                                <div class="flex d-row">
                                    <input type="tel" name="bncaccount" id="bncaccount" required validate>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="item-content item-input ">
                        <div class="item-inner">
                            <div class="item-title item-floating-label" style="background-color: #FFF !important">IFSC Code</div>
                            <div class="item-input-wrap">
                                <div class="flex d-row">
                                    <input type="text" name="bnifsc" id="bnifsc" minlength="11" maxlength="11" required validate>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="item-content item-input item-input-bank">
                        <div class="item-inner">
                            <div class="item-title item-floating-label" style="background-color: #FFF !important">Bank Name</div>
                            <div class="item-input-wrap">
                                <div class="flex d-row">
                                    <input type="text" name="bnbankname" id="bnbankname" required validate>
                                </div>
                            </div>
                        </div>
                    </li>
                    </ul>
                  </div>
                  <div class="block">
                    <button type="submit" class="button button-large button-fill color-blue bg-color-red addBeneficiaryBtn">Add Beneficiary</button>
                  </div>
                  </form>
                </div>
                </div>
              </div>
              `,
              swipeToClose: true,
              backdrop: true,
              // Events
              on: {
                open: function() {
                  // Reset form fields
                  $$('#addBeneficiaryForm')[0].reset();
                  $$('.item-input-bank').removeClass('item-input-focused item-input-with-value');
                },
                opened: function() {
                  //get ifsc
                  $(document).on('keyup', '#bnifsc', function() {
                    if($$('#bnifsc').val().length == 11) {
                      app.preloader.show();
                      $.getJSON('https://ifsc.razorpay.com/'+$$('#bnifsc').val(), function(data) {app.preloader.hide();})
                      .done(function(data) {
                        app.preloader.hide();
                        $$('#bnbankname').val(data.BANK);
                        $$('.item-input-bank').addClass('item-input-focused');
                        $$('.item-input-bank').addClass('item-input-with-value');
                      })
                      .fail(function() {
                        app.preloader.hide();
                        app.toast.show({
                          text: 'Invalid IFSC code!',
                          closeTimeout: 3000,
                        });
                      })
                    }
                  });
                  // Handle Add Beneficiary Form Submission
                  $$(document).on('submit', '#addBeneficiaryForm', function(e) {
                    e.preventDefault();
                    //check if account number and confirm account number are same
                    if($$('#bnaccount').val() !== $$('#bncaccount').val()) {
                      app.toast.show({
                        text: 'Account number and confirm account number do not match!',
                        closeTimeout: 3000,
                      });
                      return;
                    }
                    var formData = app.form.convertToData('#addBeneficiaryForm');
                    formData.addBeneficiary = true;
                    formData.token = localStorage.getItem('authToken');
                    app.dialog.progress('Adding...');
                    app.request.post(
                    baseURL + '/app/php/lockers.php',
                    formData,
                    function(res) {
                      app.dialog.close();
                      var data = {};
                      try { data = JSON.parse(res); } catch(e) {}
                      if (data.status === 'success') {
                      app.toast.show({ text: 'Beneficiary added successfully!', closeTimeout: 2000 });
                      addBeneficiarySheet.close();
                      // Optionally, reload the page or update the beneficiary list here
                      //RELOAD CURRENT PAGE
                      var view = app.views.current;
                      view.router.navigate('/invest-withdraw/', {
                        reloadCurrent: true,
                        ignoreCache: true,
                      })
                      } else {
                      app.toast.show({ text: data.msg || 'Failed to add beneficiary.', closeTimeout: 3000 });
                      }
                    },
                    function() {
                      app.dialog.close();
                      app.toast.show({ text: 'No internet connection!', closeTimeout: 3000 });
                    }
                    );
                  });
                },
                close: function() {
                  // Reset form fields
                  $$('#addBeneficiaryForm')[0].reset();
                  $$('.item-input-bank').removeClass('item-input-focused item-input-with-value');
                }
              }
            });
            // Open Add Beneficiary Sheet on button click
            $$('.add-beneficiary-btn').on('click', function() {
              addBeneficiarySheet.open();
            });
          } else {
            app.toast.show({
              text: data.msg,
              closeTimeout: 3000,
            });
            //redirect to home page
            var view = app.views.current;
            view.router.navigate({name: 'Home'});
          }
        });
        //get ifsc
        $$('#ifsc').on('keyup', function() {
          if($$('#ifsc').val().length == 11) {
            app.preloader.show();
            $.getJSON('https://ifsc.razorpay.com/'+$$('#ifsc').val(), function(data) {app.preloader.hide();})
            .done(function(data) {
              app.preloader.hide();
              $$('#bankname').val(data.BANK);
              $$('.item-input-bank').addClass('item-input-focused');
              $$('.item-input-bank').addClass('item-input-with-value');
            })
            .fail(function() {
              app.preloader.hide();
              app.toast.show({
                text: 'Invalid IFSC code!',
                closeTimeout: 3000,
              });
            })
          }
        });
        //submit withdrawal request
        $$('.withdrawMoney').on('click', function() {
          if (!$$('#investWithFrm')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            withdrawMoney();
          }
        });
        function withdrawMoney() {
          var formdata = $('#investWithFrm').serialize();
          var data = formdata+'&withdrawRequest=true&token='+localStorage.getItem('authToken');
          app.methods.request(
            baseURL+'/app/php/invest.php',
            data,
            'json',
            function() { app.dialog.progress('Loading...'); $$('.button').addClass('disabled'); },
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                app.popup.open('.sheet-loan--applied');
                $$('.sheet-loan--applied__title').html(INR2.format(data.amount)+' Withdrawal Requested!');
                $$('.sheet-loan--applied__text').html('Money will be transferred to your bank account once we verify your withdrawal, please wait while we\'re verifying your withdrawal.');
                var view = app.views.current;
                view.router.back('/invest-dashboard/',{force:true});
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
      }
    }
  },
  {
    path: '(.*)',
    component: NotFoundPage,
    on: {
      pageInit: function() {
        $$('.url').html(window.location);
      }
    }
  },
];

export default routes;